<template>
  <v-content class="bg-content">
    <v-container grid-list-xl style="padding: 10px; top: -0px">
      <v-card dark class="card-animate-2">
        <v-app-bar
          color="rgba(12, 22, 27, 0.9)"
          max-height="75"
          height="75"
          elevation="3"
          dense
          dark
        >
          <v-toolbar-title>
            <v-avatar size="40">
              <img src="@/assets/DesignIcon.png">
            </v-avatar>
            Generative AI
          </v-toolbar-title>

          <v-spacer></v-spacer>
          
        </v-app-bar>
      </v-card>
     <br />
      <v-card dark class="book-generator card-animate-2">
        <v-card-text>
          <v-form ref="form">
            <v-container grid-list-xl class="card-animate-2">
              <v-layout row wrap>
                <v-flex xs3 sm3 md3 lg3 xl3 class="stepper-flex">
                  <v-stepper v-model="currentStep">
                    <v-stepper-step :complete="currentStep > 1" step="1">Concept</v-stepper-step>
                  </v-stepper>
                </v-flex>

                <v-flex xs3 sm3 md3 lg3 xl3 class="stepper-flex">
                  <v-stepper v-model="currentStep">
                    <v-stepper-step :complete="currentStep > 2" step="2">Contents</v-stepper-step>
                  </v-stepper>
                </v-flex>

                <v-flex xs3 sm3 md3 lg3 xl3 class="stepper-flex">
                  <v-stepper v-model="currentStep">
                    <v-stepper-step :complete="currentStep > 3" step="3">Chapters</v-stepper-step>
                  </v-stepper>
                </v-flex>

                <v-flex xs3 sm3 md3 lg3 xl3 class="stepper-flex">
                  <v-stepper v-model="currentStep">
                    <v-stepper-step :complete="currentStep > 4" step="4">Images</v-stepper-step>
                  </v-stepper>
                </v-flex>
              </v-layout>
            </v-container>
<br />
<!-- Enhanced Inputs Row -->
<v-layout row wrap class="neon-form-row">
  <!-- Project Title -->
<v-flex xs12 sm6 md3>
  <v-text-field
    v-model="projectTitle"
    class="custom-text-field form-elevated"
    outlined
    rounded
    clearable
    counter="300"
    color="cyan lighten-2"
    label="Project Title"
    placeholder="e.g., Neon Skies: A Starliner Tale"
    hint="Used as the saved project name and book title"
    persistent-hint
    prepend-inner-icon="mdi-book-open-variant"
    hide-details="auto"
  />
</v-flex>

  <v-flex xs12 sm6 md3>
    <v-text-field
      v-model="bookLength"
      class="custom-text-field form-elevated"
      autocomplete="on"
      type="text"
      autofocus
      outlined
      rounded
      clearable
      counter="60"
      color="cyan lighten-2"
      label="Book Length"
      placeholder="e.g., 5–10 pages or ~60,000 words"
      hint="Accepts ranges or word counts"
      persistent-hint
      prepend-inner-icon="mdi-book-open-page-variant"
      hide-details="auto"
    >
      <template v-slot:append>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
          </template>
          <span>Used to size the outline, chapter count, and pacing.</span>
        </v-tooltip>
      </template>
    </v-text-field>
  </v-flex>

  <v-flex xs12 sm6 md3>
    <v-text-field
      v-model="gptRole"
      class="custom-text-field form-elevated"
      outlined
      rounded
      clearable
      counter="80"
      color="cyan lighten-2"
      label="Role"
      placeholder="e.g., Award-winning novelist, YA editor"
      hint="Guides tone, structure, and voice"
      persistent-hint
      prepend-inner-icon="mdi-account-tie"
      hide-details="auto"
    />
  </v-flex>

  <v-flex xs12 sm6 md3>
    <v-text-field
      v-model="genre"
      class="custom-text-field form-elevated"
      outlined
      rounded
      clearable
      counter="80"
      color="cyan lighten-2"
      label="Genre"
      placeholder="e.g., Sci-fi mystery, Kid’s adventure"
      hint="Affects imagery style and chapter cadence"
      persistent-hint
      prepend-inner-icon="mdi-shape"
      hide-details="auto"
    />
  </v-flex>

</v-layout>


<!-- Enhanced Options Row -->
<v-layout row wrap class="neon-form-row">
  <v-flex xs12 sm6 md3>
    <v-select
      v-model="projectType"
      :items="projectTypes"
      class="custom-select-field form-elevated"
      outlined
      rounded
      clearable
      color="cyan lighten-2"
      label="Project Type"
      placeholder="Choose what to create"
      hint="Affects pacing, chapters, and imagery"
      persistent-hint
      prepend-inner-icon="mdi-briefcase-variant"
      hide-details="auto"
      :menu-props="{ offsetY: true, eager: true, contentClass: 'menu-glass' }"
    />
  </v-flex>

  <v-flex xs12 sm6 md3>
    <v-text-field
      v-model.number="pageCount"
      class="custom-text-field form-elevated"
      type="number"
      min="1"
      max="20"
      outlined
      rounded
      clearable
      color="cyan lighten-2"
      label="Page Count (5–10 for short story)"
      placeholder="e.g., 8"
      hint="Used when splitting chapters into pages"
      persistent-hint
      prepend-inner-icon="mdi-file-document-multiple"
      suffix="pages"
      hide-details="auto"
    />
  </v-flex>

  <v-flex xs12 sm6 md3>
    <v-select
      v-model="globalLayout"
      :items="layoutOptions"
      class="custom-select-field form-elevated"
      outlined
      rounded
      clearable
      color="cyan lighten-2"
      label="Default Layout"
      placeholder="Cover, ImageTop, TextOnly…"
      hint="You can still change layout per page"
      persistent-hint
      prepend-inner-icon="mdi-view-grid"
      hide-details="auto"
      :menu-props="{ offsetY: true, eager: true, contentClass: 'menu-glass' }"
    />
  </v-flex>

  <v-flex xs12 sm6 md3>
    <v-select
      v-model="imageMode"
      :items="imageModeOptions"
      class="custom-select-field form-elevated"
      outlined
      rounded
      clearable
      color="cyan lighten-2"
      label="Image Mode"
      placeholder="Auto, Manual, or No Images"
      hint="“Auto” will generate per-page images"
      persistent-hint
      prepend-inner-icon="mdi-image-outline"
      hide-details="auto"
      :menu-props="{ offsetY: true, eager: true, contentClass: 'menu-glass' }"
    />
  </v-flex>
  
</v-layout>

<!-- Enhanced Image Types Row -->
<v-layout row wrap class="neon-form-row">
    <v-flex xs12 sm6 md6>
    <v-text-field
      v-model="keywords"
      class="custom-text-field form-elevated"
      outlined
      rounded
      clearable
      counter="300"
      color="cyan lighten-2"
      label="Keywords (comma-separated)"
      placeholder="spaceship, found family, neon city"
      hint="Use short, vivid terms — first 6 are weighted most"
      persistent-hint
      prepend-inner-icon="mdi-tag-multiple"
      hide-details="auto"
    />
  </v-flex>
  <v-flex xs12 sm6 md6>
    <v-select
      v-model="selectedImageTypes"
      :items="imageOptions"
      class="custom-select-field form-elevated"
      label="Select image types to generate"
      multiple
      chips
      deletable-chips
      outlined
      rounded
      clearable
      attach
      color="cyan lighten-2"
      hint="Pick any combo — cover art, characters, chapters…"
      persistent-hint
      prepend-inner-icon="mdi-image-multiple-outline"
      :menu-props="{ offsetY: true, eager: true, maxHeight: 360, contentClass: 'menu-glass' }"
      hide-details="auto"
    />
  </v-flex>

  <v-flex xs12>
    <v-text-field
      v-if="selectedImageTypes.includes('Custom Image')"
      v-model="customImagePrompt"
      class="custom-text-field form-elevated"
      outlined
      rounded
      clearable
      counter="200"
      color="cyan lighten-2"
      label="Custom Image Prompt"
      placeholder="Describe a scene, style, and mood…"
      hint="Supports inline directives like “| size:1024x1792 | style: watercolor”"
      persistent-hint
      prepend-inner-icon="mdi-text"
      hide-details="auto"
    />
  </v-flex>
</v-layout>


            <v-layout row wrap>
              <!-- <v-flex xs12 sm6 md4>
                <v-checkbox v-model="autoGenerateChapters" label="Auto Generate Chapters"></v-checkbox>
              </v-flex> -->
              <v-flex xs12>
                <button color="primary" class="buttongenerate" @click.prevent="generateConcept">Concept</button>
                <button color="primary" class="buttongenerate" @click.prevent="generateTableOfContents">Contents</button>
                <button color="primary" class="buttongenerate" @click.prevent="generateChapters">Chapters</button>
                <button color="primary" class="buttongenerate" @click.prevent="image">Images</button>
<button color="primary" class="buttongenerate" @click.prevent="runFullPipeline">
  Complete Project
</button>                <button color="primary" class="buttongenerate" @click.prevent="exportToTxtMethod">Export to TXT</button>
              </v-flex>
            </v-layout>
<!-- Book actions -->


            <v-divider class="my-6"></v-divider>

<v-layout row wrap class="mt-4">
  <v-flex xs12 md4>
    <v-card outlined class="pa-3 mb-4">
      <v-card-title class="subtitle-2 grey--text text--lighten-1">
        Concept
        <v-spacer></v-spacer>
        <v-chip small label>{{ (concept || '').length }} chars</v-chip>
      </v-card-title>
      <v-card-text>
        <v-textarea
          v-model="concept"
          readonly
          auto-grow
          rows="8"
          outlined
          id="book-concept"
          class="textarea-height"
        ></v-textarea>
      </v-card-text>
    </v-card>
  </v-flex>

  <v-flex xs12 md4>
    <v-card outlined class="pa-3 mb-4">
      <v-card-title class="subtitle-2 grey--text text--lighten-1">
        Table of Contents
        <v-spacer></v-spacer>
        <v-chip small label>{{ (tableOfContents || '').split('\n').filter(Boolean).length }} items</v-chip>
      </v-card-title>
      <v-card-text>
        <v-textarea
          v-model="tableOfContents"
          readonly
          auto-grow
          rows="8"
          outlined
          id="table-of-contents"
          class="textarea-height"
        ></v-textarea>
      </v-card-text>
    </v-card>
  </v-flex>

  <v-flex xs12 md4>
    <v-card outlined class="pa-3 mb-4">
      <v-card-title class="subtitle-2 grey--text text--lighten-1">
        Chapters (raw)
        <v-spacer></v-spacer>
        <v-chip small label>{{ (chaptersHtml || '').length }} chars</v-chip>
      </v-card-title>
      <v-card-text>
        <v-textarea
          v-model="chaptersHtml"
          auto-grow
          rows="8"
          outlined
          id="chapters"
          class="chapters textarea-height"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-btn small text color="primary" @click="readOutLoudText(chaptersHtml)">Dictate</v-btn>
        <v-btn small text color="primary" @click="exportToTxtMethod">Export TXT</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</v-layout>



            <v-layout>
              <v-btn color="primary" @click="readOutLoudText(chaptersHtml)">Dictate</v-btn>
              <v-btn color="error" class="ml-2" @click="stopReading">Stop</v-btn>
            </v-layout>

            <v-divider class="my-6"></v-divider>

            <v-layout row wrap>
              <v-flex xs12 sm6 md2>
                <v-btn color="primary" class="buttongenerate" @click="generateProject">Generate {{ projectType }}</v-btn>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-btn color="primary" class="buttongenerate" @click="addBlankPage">Add Blank Page</v-btn>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-btn color="primary" class="buttongenerate" @click="toggleLivePreview">
                  {{ livePreview ? 'Hide' : 'Show' }} Preview
                </v-btn>
              </v-flex>


            <div v-if="showTimer">
              <v-progress-linear :value="timeLeftPercentage"></v-progress-linear>
              <p>{{ statusMessage }}</p>
            </div>

<v-flex xs12 sm6 md2>
  <v-btn color="primary" class="buttongenerate" @click="saveProject">
    Save Project
  </v-btn>
</v-flex>

<v-flex xs12 sm6 md2>
  <v-btn color="primary" class="buttongenerate" @click="saveProjectAsCopy">
    Save As Copy
  </v-btn>
</v-flex>

  <v-flex xs12 sm6 md2>
    <v-btn color="primary" class="buttongenerate" @click="openBookViewer()">Open Book Viewer</v-btn>
  </v-flex>
  <v-flex xs12 sm12 md12>
    <v-select
      v-model="currentProjectId"
      :items="projectItems"
      item-text="text"
      item-value="value"
      label="Saved Projects"
      class="custom-select-field"
    ></v-select>
    <v-btn small class="ml-2" color="primary" @click="loadProject(currentProjectId)" :disabled="!currentProjectId">Load</v-btn>
    <v-btn small class="ml-1" color="error" @click="deleteProject(currentProjectId)" :disabled="!currentProjectId">Delete</v-btn>
  </v-flex>
</v-layout>
          </v-form>
        </v-card-text>
      </v-card>
      <br />
      <!-- BOOK VIEWER (Flip-style layout) -->
<v-dialog v-model="showBookViewer" max-width="1200">
  <v-card class="book-viewer">
    <v-card-title class="justify-space-between">
      <div class="subtitle-1">Book Viewer • {{ bookTitle }}</div>
      <div>
        <v-btn small text color="primary" @click="prevPage" :disabled="currentPageIndex<=0">
          <v-icon left>mdi-chevron-left</v-icon>Prev
        </v-btn>
        <v-btn small text color="primary" @click="nextPage" :disabled="currentPageIndex>=pages.length-1">
          Next<v-icon right>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn small text color="primary" class="ml-2" @click="downloadBookJson">Download JSON</v-btn>
        <v-btn small text color="error" class="ml-2" @click="showBookViewer=false">Close</v-btn>
      </div>
    </v-card-title>

    <v-card-text>
      <div class="flipbook-wrap">
        <div class="spread">
         <!-- inside .spread -->
<!-- LEFT PAGE -->
<div class="book-page" v-if="leftPage" :class="pageClassForType(projectType,'left')">
  <div class="page-inner">
    <template v-if="projectType.includes('Comic')">
      <div class="comic-grid">
        <div v-for="(panel,pi) in comicPanels(leftPage)" :key="'lp'+pi" class="panel">
          <img v-if="panel.img" :src="panel.img" />
          <div class="panel-text" v-if="panel.text">{{ panel.text }}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="page-image" v-if="leftPage.imageUrl"><img :src="leftPage.imageUrl" /></div>
      <div class="page-text" v-if="leftPage.text">
        <h3 class="page-title" v-if="isCover(leftIndex)">{{ bookTitle }}</h3>
        <pre class="page-pre" :class="typographyForType(projectType)">{{ leftPage.text }}</pre>
      </div>
    </template>
  </div>
</div>

<!-- RIGHT PAGE mirrors LEFT -->
<div class="book-page" v-if="rightPage" :class="pageClassForType(projectType,'right')">
  <div class="page-inner">
    <template v-if="projectType.includes('Comic')">
      <div class="comic-grid">
        <div v-for="(panel,pi) in comicPanels(rightPage)" :key="'rp'+pi" class="panel">
          <img v-if="panel.img" :src="panel.img" />
          <div class="panel-text" v-if="panel.text">{{ panel.text }}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="page-image" v-if="rightPage.imageUrl"><img :src="rightPage.imageUrl" /></div>
      <div class="page-text" v-if="rightPage.text">
        <pre class="page-pre" :class="typographyForType(projectType)">{{ rightPage.text }}</pre>
      </div>
    </template>
  </div>
</div>
        </div>
      </div>

      <!-- Thumbnails / quick nav -->
      <div class="thumbs">
        <div
          v-for="(p, i) in pages"
          :key="'thumb-'+i"
          class="thumb"
          :class="{ active: i===currentPageIndex || i===currentPageIndex+1 }"
          @click="goToPage(i)"
          :title="'Go to page '+(i+1)"
        >
          <img v-if="p.imageUrl" :src="p.imageUrl" />
          <div v-else class="thumb-text">{{ p.text ? p.text.slice(0,50) : '—' }}</div>
          <div class="thumb-label"> {{ i+1 }} </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</v-dialog>

      <br />
      <v-card dark class="book-generator card-animate-2">
        <v-card-title>Template Preview</v-card-title>
        <!-- Global image batch progress -->
<div v-if="imageBatch.isRunning" class="mt-3 mb-1">
  <v-progress-linear
    :value="imageBatch.percent"
    color="cyan lighten-2"
    height="8"
    rounded
  ></v-progress-linear>
  <div class="caption status mt-1">
    {{ imageBatch.status }} ({{ imageBatch.current }}/{{ imageBatch.total }}) • {{ imageBatch.etaText }}
  </div>
</div>

        <v-card-text>
          <v-layout row wrap>
            <v-flex v-for="(page, idx) in pages" :key="'page-'+idx" xs12 sm6 md4>
              <v-card class="pa-3 mb-4 page-card" :class="'layout-'+page.layout">
                <div class="page-header d-flex align-center justify-space-between">
                  <span class="caption grey--text">{{ projectType }} • Page {{ idx + 1 }} • {{ page.layout }}</span>
                  <div>
                    <v-btn small icon @click="movePage(idx, -1)" :disabled="idx===0" title="Move Up">
                      <v-icon>mdi-arrow-up</v-icon>
                    </v-btn>
                    <v-btn small icon @click="movePage(idx, 1)" :disabled="idx===pages.length-1" title="Move Down">
                      <v-icon>mdi-arrow-down</v-icon>
                    </v-btn>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn small icon v-bind="attrs" v-on="on" title="Change Layout"><v-icon>mdi-view-grid</v-icon></v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-for="lo in layoutOptions" :key="lo" @click="setPageLayout(idx, lo)">
                          <v-list-item-title>{{ lo }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-btn small icon color="error" @click="removePage(idx)" title="Delete Page">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </div>
<!-- Per-page Prompt Studio Controls -->



<!-- Prompt Studio Dialog -->
<v-dialog v-model="showPromptStudio" max-width="900">
  <v-card class="book-viewer">
    <v-card-title class="justify-space-between">
      <div class="subtitle-1">Prompt Studio</div>
      <v-btn icon @click="showPromptStudio=false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-textarea
        v-model="promptStudio.input"
        label="Base Prompt"
        auto-grow
        rows="5"
        outlined
        class="textarea-height"
      />
      <div class="mt-3">
        <v-text-field
          v-model="promptStudio.style"
          label="Style"
          outlined
          class="custom-text-field"
          prepend-inner-icon="mdi-brush"
        />
        <v-select
          v-model="promptStudio.size"
          :items="['1024x1024','1024x1792','1792x1024']"
          label="Size"
          outlined
          class="custom-select-field"
          prepend-inner-icon="mdi-aspect-ratio"
        />
        <v-select
          v-model="promptStudio.quality"
          :items="['standard','hd']"
          label="Quality"
          outlined
          class="custom-select-field"
          prepend-inner-icon="mdi-star"
        />
      </div>

      <v-textarea
        v-model="promptStudio.preview"
        label="Final (coerced) Prompt"
        readonly
        auto-grow
        rows="4"
        outlined
        class="textarea-height mt-3"
      />

      <div class="mt-2 d-flex">
        <v-btn small text class="ml-2" @click="exportPDF">
  <v-icon left>mdi-file-pdf-box</v-icon>Export PDF
</v-btn>
<v-btn small text class="ml-2" @click="shareProject">
  <v-icon left>mdi-share-variant</v-icon>Share
</v-btn>
<v-btn small text class="ml-2" @click="emailProject">
  <v-icon left>mdi-email</v-icon>Email
</v-btn>

        <v-btn class="mr-2" @click="studioCoerce">Coerce</v-btn>
        <v-btn class="mr-2" color="primary" @click="applyStudioPrompt">Use This Prompt</v-btn>
        <v-btn text @click="showPromptStudio=false">Close</v-btn>
      </div>
    </v-card-text>
  </v-card>
</v-dialog>
                <div v-if="page.layout==='Cover' || page.layout==='ImageTop'">
                  <div v-if="page.imageUrl" class="page-image">
                    <img :src="page.imageUrl" alt="Page Image">
                  </div>
                </div>

                <div v-if="page.layout==='ImageLeft'" class="layout-row">
                  <div class="page-image" v-if="page.imageUrl">
                    <img :src="page.imageUrl" alt="Page Image">
                  </div>
                  <v-textarea
                    v-model="page.text"
                    class="page-text ml-3"
                    auto-grow
                    outlined
                    :label="'Page '+(idx+1)+' Text'"
                  ></v-textarea>
                </div>

                <div v-else-if="page.layout==='ImageRight'" class="layout-row">
                  <v-textarea
                    v-model="page.text"
                    class="page-text mr-3"
                    auto-grow
                    outlined
                    :label="'Page '+(idx+1)+' Text'"
                  ></v-textarea>
                  <div class="page-image" v-if="page.imageUrl">
                    <img :src="page.imageUrl" alt="Page Image">
                  </div>
                </div>

                <div v-else-if="page.layout==='TextOnly'">
                  <v-textarea
                    v-model="page.text"
                    class="page-text"
                    auto-grow
                    outlined
                    :label="'Page '+(idx+1)+' Text'"
                  ></v-textarea>
                </div>

                <div v-else-if="page.layout==='ImageGrid'">
                  <div class="grid-2">
                    <div v-for="(u,i) in page.gridUrls" :key="'g'+i" class="grid-cell">
                      <img v-if="u" :src="u" alt="Grid Image">
                      <div v-else class="grid-placeholder">No Image</div>
                    </div>
                  </div>
                  <v-textarea
                    v-model="page.text"
                    class="page-text mt-3"
                    auto-grow
                    outlined
                    :label="'Page '+(idx+1)+' Caption/Text'"
                  ></v-textarea>
                </div>

                <!-- <div v-else>
                  <v-textarea
                    v-model="page.text"
                    class="page-text"
                    auto-grow
                    outlined
                    :label="'Page '+(idx+1)+' Text'"
                  ></v-textarea>
                </div> -->

                <div v-if="page.layout==='Cover' || page.layout==='ImageTop'">
                  <v-textarea
                    v-model="page.text"
                    class="page-text mt-3"
                    auto-grow
                    outlined
                    :label="'Page '+(idx+1)+' Text'"
                  ></v-textarea>
                </div>

<div class="d-flex mt-2">
  <v-text-field
    v-model="page.imagePrompt"
    class="flex-grow-1 mr-2"
    label="Image Prompt (supports | size: | style: | quality: | n: )"
  ></v-text-field>
  <v-btn
    small
    color="primary"
    :loading="page._loading === true"
    :disabled="page._loading === true"
    @click="generatePageImage(idx)"
  >
    Gen Img
  </v-btn>
  
</div>
<v-layout row wrap class="neon-form-row mt-2">
  <v-flex xs12 sm6 md4>
    <v-btn block class="buttongenerate2" @click="openPromptStudio(idx)">
      Studio
    </v-btn>
  </v-flex>
  <v-flex xs12 sm6 md4>
    <v-btn block class="buttongenerate2" @click="quickRegeneratePrompt(idx)">
      Prompt
    </v-btn>
  </v-flex>
  <v-flex xs12 sm6 md4>
    <v-btn
      block
      class="buttongenerate2"
      color="primary"
      @click="generateImageWithCurrentPrompt(idx)"
    >
      Image
    </v-btn>
  </v-flex>
</v-layout>
<div v-if="page._loading" class="caption mt-1">{{ page._status || 'Generating…' }}</div>
<div v-if="page._error" class="error--text caption mt-1">{{ page._error }}</div>

              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
<!-- Images Panel -->
<div v-if="showImagesPanel" class="book-generator card-animate-2 images-panel">
  <v-card-title>Images</v-card-title>

  <!-- Close (top-right) -->
  <!-- <v-btn
    class="panel-close"
    elevation="4"
    @click="showImagesPanel = false"
    aria-label="Close Images Panel"
    title="Close"
  >
    <v-icon large>mdi-close</v-icon>
  </v-btn> -->

  <ul class="image-gallery">
  <li
    v-for="(savedImage, index) in savedImages"
    :key="index"
    class="image-thumb"
    @click="openLightbox(savedImage, index)"
  >
    <img :src="savedImage.url" :alt="savedImage.prompt || 'Saved Image'" />
  </li>
</ul>

<!-- Lightbox Overlay -->
<transition name="fade-zoom">
  <div
    v-if="isLightboxOpen"
    class="lightbox-overlay"
    @click.self="closeLightbox"     
    @keydown.esc="closeLightbox"     
    tabindex="0"
    role="dialog"
    aria-modal="true"
    :aria-label="lightboxImage?.prompt || 'Image preview'"
  >
    <div class="lightbox-card" @click.stop> <!-- prevent inner clicks from closing -->
      <!-- Big animated close button -->
      <button
        class="lightbox-close"
        type="button"
        aria-label="Close"
        title="Close"
        @click.stop="closeLightbox"
      >
        ✕
      </button>

      <div class="lightbox-media">
        <img :src="lightboxImage.url" :alt="lightboxImage.prompt || 'Saved Image'" />
      </div>

      <div class="lightbox-meta">
        <div class="prompt">{{ lightboxImage.prompt }}</div>
      </div>

      <div class="lightbox-actions">
        <v-btn class="mb-2" color="primary" @click.stop="editSavedImage(lightboxIndex)">
          Edit
        </v-btn>
        <v-btn class="mb-2" color="error" @click.stop="deleteSavedImage(lightboxIndex)">
          Delete
        </v-btn>
        <v-btn class="mb-2" outlined @click.stop="closeLightbox">
          Close
        </v-btn>
      </div>
    </div>
  </div>
</transition>


  <SavedImageList
    :saved-items="savedImages"
    @edit-item="editSavedImage"
    @delete-item="deleteSavedImage"
  />

  <div v-if="isLightboxOpen" class="lightbox">
    <img :src="lightboxImage.url" alt="Lightbox Image" />
    <div>{{ lightboxImage.prompt }}</div>
    <v-btn class="mb-4 download-btn" @click="editSavedImage(lightboxIndex)">Edit</v-btn>
    <v-btn class="mb-4 save-btn" @click="deleteSavedImage(lightboxIndex)">Delete</v-btn>
    <v-btn class="mb-4 close-btn" @click="closeLightbox">Close</v-btn>
  </div>
</div>

    </v-container>
    <br />
    <v-divider></v-divider>
    <br />
    <v-container grid-list-xl>
      <v-flex xs12>
        <div>
          <form @submit.prevent="image">
            <v-text-field
              v-model="imagePrompt"
              label="Enter your prompt for the image"
              required
              clearable
              counter
              placeholder="Enter your prompt for the image"
              full-width
              multi-line
              class="inputarea"
            ></v-text-field>
            <br />
            <v-icon :color="recordingStateColor">mdi-microphone</v-icon>

            <v-btn class="btn btn-primary mb-4" @click="promptUserAndStartRecording" v-if="!isRecording">Start</v-btn>
            <v-btn class="btn btn-primary mb-4" @click="stopRecording" v-if="isRecording">Listening</v-btn>
            <v-btn class="btn btn-primary mb-4" style="margin-left: 10px;" color="primary" type="submit">Generate Image</v-btn>
          </form>

          <div v-if="generatedImageUrl" class="bookimage-container">
            <v-btn class="mb-4 download-btn" style="text-decoration: none !important;" :href="generatedImageUrl" target="_blank" download="generated-image">Download</v-btn>
            <v-btn class="mb-4 save-btn" @click="saveImage">Save Image</v-btn>
            <v-btn class="mb-4 close-btn" dark @click="generatedImageUrl = false">X</v-btn>
            <h3></h3>
            <img style="margin-top: -130px; padding-block: 60px;" :src="generatedImageUrl" alt="Generated Image" />
          </div>

          <div v-if="loading" class="loading-container">
            <img class="mx-auto d-block" style="height: 25%; width: 25%" src="../assets/images/loading-spinner15.gif" alt="Loading" />
            <br />
            <p>{{ loadingText }}</p>
          </div>
          <br />

          <br />


          <div v-if="editedImageUrl" class="edited-bookimage-container">
            <img :src="editedImageUrl" alt="Edited Image" />
            <button @click="downloadEditedImage">Download Edited Image</button>
          </div>

          <div v-if="imageEditorOpen" class="image-editor-container">
            <canvas id="canvas" width="800" height="600"></canvas>
            <button @click="addRectangle">Add Rectangle</button>
            <button @click="addCircle">Add Circle</button>
            <button @click="addText">Add Text</button>
            <button @click="saveEditedImage">Save Image</button>
            <button @click="closeImageEditor">Close Editor</button>
          </div>
          <notifications ref="notifications"></notifications>
        </div>

        <br />
        <br />
        <br />
      </v-flex>
    </v-container>

    <div v-if="showImageOverlay" class="overlay">
      <img src="@/assets/images/loading-spinner15.gif" alt="Cognitive AI" class="animated-image">
    </div>
  </v-content>
</template>

<script>
import { generateConcept, generateTableOfContents, generateChapters, exportToTxt, generateImagePrompt } from './bookscript.js';
import { apiKey } from './apikey.js';
import submitAudio from '../assets/audio/input1.wav';
import codeCompleteAudio from "../assets/audio/SelectNew.wav";
import SavedImageList from './SavedImageList.vue';
import Notifications from './Notification.vue';
import { fabric } from 'fabric';
import axios from "axios";

// Place these helpers near your existing `parseImageInput` / `delay` helpers (module scope)

function stripHtml(s = "") {
  return String(s).replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

/**
 * Shortens an image prompt while preserving inline directives like:
 * " | size:1024x1024 | quality:hd | n:2 | style: watercolor"
 */
function sanitizeAndShortenImagePrompt(input, maxChars = 3800) {
  if (!input) return "";
  const parts = String(input).split("|").map(p => p.trim());
  const core = stripHtml(parts.shift() || "");
  const directives = parts.length ? " | " + parts.join(" | ") : "";

  // Limit the core to ~60 words for safety
  let coreLimited = core.split(/\s+/).slice(0, 60).join(" ");
  if (coreLimited !== core) coreLimited += "…";

  let out = `${coreLimited}${directives ? " " + directives : ""}`.replace(/\s+\|\s+/g, " | ");
  if (out.length > maxChars) {
    // If still too long, reserve space for directives and trim core accordingly
    const dirStart = out.indexOf(" | ");
    if (dirStart > -1) {
      const dir = out.slice(dirStart);
      const allowedCore = Math.max(0, maxChars - dir.length - 1);
      out = (coreLimited.slice(0, allowedCore).trim() + "…") + dir;
    } else {
      out = out.slice(0, maxChars - 1).trim() + "…";
    }
  }
  return out;
}

/** Parse combined string: "prompt | size:1024x1024 | quality:hd | n:2 | style: cyberpunk" */
function parseImageInput(input) {
  const out = { prompt: "", size: "1024x1024", quality: "standard", n: 1, style: "" };
  if (!input) return out;
  const parts = String(input).split("|").map(p => p.trim()).filter(Boolean);
  out.prompt = parts.shift() || "";
  for (const part of parts) {
    const [kRaw, ...rest] = part.split(":");
    const k = (kRaw || "").toLowerCase().trim();
    const v = (rest.join(":") || "").trim();
    if (!k || !v) continue;
    if (k === "size") out.size = v;
    else if (k === "quality") out.quality = v;
    else if (k === "n") out.n = Math.max(1, parseInt(v, 10) || 1);
    else if (k === "style") out.style = v;
  }
  return out;
}
// >>> ADD: utility: strip “Title/Logline/Include” boilerplate & odd punctuation
function normalizeText(s = "") {
  return String(s)
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/\u2014/g, "-")   // em dash → hyphen
    .replace(/\u2026/g, "...") // ellipsis
    .replace(/\s+/g, " ")
    .trim();
}

// >>> ADD: remove duplicated directives and keep only FIRST of each
function dedupeDirectives(parts) {
  const seen = { size: false, quality: false, n: false, style: false };
  const kept = [];
  for (const p of parts) {
    const [kRaw, ...rest] = p.split(":");
    const k = (kRaw || "").toLowerCase().trim();
    if (!k || !rest.length) { kept.push(p.trim()); continue; }
    if (k in seen) {
      if (seen[k]) continue;
      seen[k] = true;
      kept.push(`${k}:${rest.join(":").trim()}`);
    } else {
      kept.push(p.trim());
    }
  }
  return kept;
}

// >>> ADD: Ensure it becomes: "Illustrate ... | size:... | quality:... | style:..."
function coerceToWorkingPrompt(input, fallbackTitle = "Untitled", opts = {}) {
  const {
    defaultSize = "1024x1792",
    defaultQuality = "hd",
    defaultStyle = "painted realism, cinematic lighting",
    forbidText = true
  } = opts;

  let raw = normalizeText(input || "");
  // kill boilerplate chunks that confuse parsers
  raw = raw.replace(/\b(?:Title|Logline|Include|Motif)\s*:\s*[^|]+/gi, "").trim();

  // Split into “core | directives”
  const parts = raw.split("|").map(s => s.trim()).filter(Boolean);
  let core = parts.shift() || "";

  // If the core starts with "Book cover for" or anything else, normalize to "Illustrate …"
  // Also handle accidental clipped words etc.
  if (!/^illustrate\b/i.test(core)) {
    // Build a safe subject if we can infer one
    const titleMatch = core.match(/"([^"]+)"/);
    const inferredTitle = titleMatch?.[1] || fallbackTitle;
    // Prefer “book cover” phrasing if user hints at cover, else generic scene
    if (/cover/i.test(core)) {
      core = `Illustrate a book cover for "${inferredTitle}" (highly detailed, dramatic)`;
    } else {
      core = `Illustrate this scene from "${inferredTitle}"`;
    }
  }

  // Add strong guardrails to avoid rendered text
  if (forbidText && !/do not include/i.test(core)) {
    core += `; do not include any text, titles, logos, page numbers, or watermarks`;
  }

  // Rebuild directives, dedup size/quality/n/style, normalize size values
  let directives = dedupeDirectives(parts).map(s => s.replace(/\s+/g, " "));

  // Ensure one valid size & quality & style present
  let hasSize = directives.some(d => /^size:/i.test(d));
  let hasQuality = directives.some(d => /^quality:/i.test(d));
  let hasStyle = directives.some(d => /^style:/i.test(d));
  // Normalize size values to allowed set
  directives = directives.map(d => {
    if (/^size:/i.test(d)) {
      const v = d.split(":")[1]?.trim() || defaultSize;
      return `size:${normalizeImageSize(v)}`;
    }
    return d;
  });
  if (!hasSize) directives.unshift(`size:${defaultSize}`);
  if (!hasQuality) directives.push(`quality:${defaultQuality}`);
  if (!hasStyle) directives.push(`style:${defaultStyle}`);

  const prompt = `${core}. | ${directives.join(" | ")}`;
  return sanitizeAndShortenImagePrompt(prompt, 3600);
}

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
// --- Add this helper near your other module-scope helpers (e.g., next to parseImageInput) ---
function normalizeImageSize(size) {
  const allowed = new Set(["1024x1024", "1024x1792", "1792x1024"]);
  if (allowed.has(size)) return size;
  if (size === "1024x1536" || size === "1536x1024") return "1024x1792"; // closest portrait
  try {
    const [w, h] = String(size || "").toLowerCase().split("x").map(n => parseInt(n, 10));
    if (!w || !h) return "1024x1024";
    return h >= w ? "1024x1792" : "1792x1024";
  } catch {
    return "1024x1024";
  }
}
async function loadScript(src) {
  return new Promise((res, rej) => {
    const s = document.createElement('script');
    s.src = src; s.async = true; s.onload = res; s.onerror = rej;
    document.head.appendChild(s);
  });
}


export default {
  data() {
    return {
      currentStep: 0,
      bookLength: '',
      gptRole: '',
      genre: '',
      keywords: '',
      autoGenerateChapters: false,
      showImageOverlay: false,
      concept: '',
      tableOfContents: '',
      chaptersHtml: '',
      imageOptions: ['Cover Art', 'Main Characters', 'Chapters Cover', 'Pivotal Moments', 'Custom Image'],
      showTimer: false,
      timeLeft: 0,
      timeLeftPercentage: 0,
      statusMessage: '',
      imageEditorOpen: false,
      canvas: null,
      imagePrompt: '',
      editedImageUrl: null,
      loading: false,
      loadingText: 'Generating Image...',
      gptApiKey: apiKey,
      selectedImageTypes: [],
      customImagePrompt: "",
      generatedImageUrl: "",
      generatedImageUrls: [],
      isRecording: false,
showPromptStudio: false,
    promptStudio: {
      input: "",
      style: "painted realism, cinematic lighting",
      size: "1024x1792",
      quality: "hd",
      preview: "",
      pageIndex: null, // <— track which page we're editing
    },
projectTitle: "",          // <-- NEW: user-entered title
    projects: JSON.parse(localStorage.getItem('savedBooks') || '[]'),
    currentProjectId: null,
    showBookViewer: false,
    currentPageIndex: 0, // left page index in viewer
      savedImages: JSON.parse(localStorage.getItem("savedImages") || "[]"),
      editingImageIndex: -1,
      downloadImageUrl: null,
      isLightboxOpen: false,
      lightboxImage: null,
      lightboxIndex: null,
      recognition: null,
      recordingStateColor: 'green',
      speechSynthesisUtterance: null,
      speechSynthesisPaused: false,
      speechSynthesisIndex: 0,
      availableVoices: [],
      preferredVoices: [
        'Google UK English Male',
        'Google UK English Female',
        'Google US English'
      ],
      
      imageBatch: {
  isRunning: false,
  current: 0,
  total: 0,
  percent: 0,
  status: 'Preparing images…',
  etaText: ''
},
imageBatchIntervalId: null,
showImagesPanel: true,
      voiceOptions: [],
      selectedVoiceName: '',
      selectedVoice: null,
      
      /* NEW: Project controls */
      projectType: 'Short',
      projectTypes: ['Script (No Images)', 'Short (5–10 pages)', 'Kids (Images)', 'Comic (Images)', 'Custom'],
      pageCount: 8,
      layoutOptions: ['Cover', 'ImageTop', 'ImageLeft', 'ImageRight', 'ImageGrid', 'TextOnly'],
      globalLayout: 'ImageTop',
      imageModeOptions: ['No Images', 'Auto (Per Page)', 'Manual Only'],
      imageMode: 'Auto (Per Page)',

      /* NEW: Pages structure for realtime preview */
      pages: [],
      livePreview: true
    };
  },
  components: {
    SavedImageList,
    Notifications
  },
  computed: {
    craftedImagePrompt() {
      const title = (this.tableOfContents || '').split('\n')[0]?.trim() || 'Untitled';
      const genre = (this.genre || 'fiction').trim();
      const concept = (this.concept || '').trim();
      const keywords = String(this.keywords || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
      return generateImagePrompt({ title, genre, keywords, concept });
    },
projectItems() {
  return this.projects.map(p => ({
    text: `${p.title || 'Untitled'} • ${new Date(p.savedAt).toLocaleString()}`,
    value: p.id
  }));
},

bookTitle() {
    const explicit = (this.projectTitle || '').trim();
    if (explicit) return explicit;
    const fromToc = (this.tableOfContents || '').split('\n').filter(Boolean)[0];
    return fromToc || 'Untitled';
  },
  leftIndex() { return this.currentPageIndex; },
  rightIndex() { return Math.min(this.currentPageIndex + 1, Math.max(0, this.pages.length - 1)); },
  leftPage() { return this.pages[this.leftIndex] || null; },
  rightPage() { return this.pages[this.rightIndex] || null; },
  currentPageIndexLabel() { return this.currentPageIndex + 1; }
  },
mounted() {
  this.initSpeechSynthesis();
  if (!this.imagePrompt?.trim()) this.imagePrompt = this.craftedImagePrompt;
  // refresh saved projects
  this._refreshProjects();
  // keyboard nav in viewer
  window.addEventListener('keydown', this._bookKeyNav);
  window.addEventListener('keydown', this._imagesEsc);
},
beforeDestroy() {
  window.removeEventListener('keydown', this._bookKeyNav);
  window.removeEventListener('keydown', this._imagesEsc);
},

  methods: {
    /* ====== AUDIO ====== */
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
        return voice.name === voiceName;
      })[0];
      speech.text = msg;
      window.speechSynthesis.speak(speech);
    },
    readOutLoudText(text) {
      if (speechSynthesis.speaking || speechSynthesis.paused) {
        speechSynthesis.cancel();
      }
      this.speechSynthesisUtterance = new SpeechSynthesisUtterance(text);
      const voiceName = this.preferredVoices[0] || 'Google UK English';
      this.speechSynthesisUtterance.voice = speechSynthesis.getVoices().find(voice => voice.name === voiceName);
      this.speechSynthesisUtterance.volume = 1.0;
      this.speechSynthesisUtterance.rate = 0.95;
      this.speechSynthesisUtterance.pitch = 1.0;
      speechSynthesis.speak(this.speechSynthesisUtterance);
    },
    stopReading() {
      if (speechSynthesis.speaking) {
        speechSynthesis.cancel();
        this.speechSynthesisPaused = false;
      }
    },
    _imagesEsc(e) {
      if (e.key === 'Escape' && this.showImagesPanel) this.showImagesPanel = false;
    },
/* ====== IMAGE BATCH: progress helpers ====== */
_setImageBatchStatus({ current, total, status }) {
  if (typeof current === 'number') this.imageBatch.current = current;
  if (typeof total === 'number') this.imageBatch.total = total;
  if (typeof status === 'string') this.imageBatch.status = status;
  const pct = total > 0 ? Math.round((this.imageBatch.current / total) * 100) : 0;
  this.imageBatch.percent = Math.min(100, Math.max(0, pct));
},
// --- In methods: update timer helpers to use the new name ---
_startImageBatchTimer() {
  const t0 = Date.now();
  if (this.imageBatchIntervalId) clearInterval(this.imageBatchIntervalId);
  this.imageBatchIntervalId = setInterval(() => {
    const elapsed = Math.max(1, Math.round((Date.now() - t0) / 1000));
    const remaining = Math.max(0, (this.imageBatch.total - this.imageBatch.current));
    const eta = remaining * 5;
    this.imageBatch.etaText = `Elapsed ${elapsed}s • ETA ~${eta}s`;
  }, 1000);
},
_stopImageBatchTimer() {
  if (this.imageBatchIntervalId) {
    clearInterval(this.imageBatchIntervalId);
    this.imageBatchIntervalId = null;
  }
},
openPromptStudio(pageIndex = null) {
    this.promptStudio.pageIndex = pageIndex;

    let base;
    if (Number.isInteger(pageIndex) && this.pages[pageIndex]) {
      base = (this.pages[pageIndex].imagePrompt || '').trim();
      if (!base) base = this.buildPageImagePrompt(pageIndex);
    } else {
      base = (this.selectedImageTypes?.includes('Custom Image') && this.customImagePrompt?.trim())
        ? this.customImagePrompt
        : (this.imagePrompt || this.craftedImagePrompt);
    }

    this.promptStudio.input = base || '';
    this.studioCoerce(); // fills preview using current style/size/quality
    this.showPromptStudio = true;
  },

  // Re-roll a quick variant for THIS page
  quickRegeneratePrompt(pageIndex = null) {
    const seed =
      (Number.isInteger(pageIndex) && this.pages[pageIndex])
        ? (this.pages[pageIndex].imagePrompt || this.buildPageImagePrompt(pageIndex) || this.craftedImagePrompt)
        : (this.craftedImagePrompt || this.imagePrompt || '');

    const variants = [
      "gritty, filmic, high contrast",
      "soft volumetric light, airy, painterly",
      "noir, chiaroscuro, dramatic",
      "vibrant, saturated, graphic novel inking",
      "storybook watercolor, warm, friendly"
    ];
    const style = variants[Math.floor(Math.random() * variants.length)];
    const next = `${(seed || '').trim()} | style:${style}`;
    const coerced = coerceToWorkingPrompt(next, this.bookTitle);

    if (Number.isInteger(pageIndex) && this.pages[pageIndex]) {
      this.$set(this.pages[pageIndex], 'imagePrompt', coerced);
    } else if (this.selectedImageTypes?.includes('Custom Image')) {
      this.customImagePrompt = coerced;
    } else {
      this.imagePrompt = coerced;
    }

    this.showNotification?.("New prompt generated.", "success");
  },

  // Keep your existing studioCoerce() — no change needed

  // Apply the dialog's coerced prompt to the targeted page (or global as fallback)
  applyStudioPrompt() {
    const p = (this.promptStudio.preview || '').trim();
    if (!p) return;

    const i = this.promptStudio.pageIndex;
    if (Number.isInteger(i) && this.pages[i]) {
      this.$set(this.pages[i], 'imagePrompt', p);
    } else if (this.selectedImageTypes?.includes('Custom Image')) {
      this.customImagePrompt = p;
    } else {
      this.imagePrompt = p;
    }

    this.showPromptStudio = false;
  },

  // One-click: use current prompt on that page and generate its image
  async generateImageWithCurrentPrompt(pageIndex) {
    if (!Number.isInteger(pageIndex) || !this.pages[pageIndex]) return;

    // Ensure the page has a prompt; if dialog is open and on this page, prefer preview
    if (this.showPromptStudio && this.promptStudio.pageIndex === pageIndex && this.promptStudio.preview?.trim()) {
      this.$set(this.pages[pageIndex], 'imagePrompt', this.promptStudio.preview.trim());
    } else if (!this.pages[pageIndex].imagePrompt?.trim()) {
      this.$set(this.pages[pageIndex], 'imagePrompt', this.buildPageImagePrompt(pageIndex));
    }

    await this.generatePageImage(pageIndex);
  },
studioCoerce() {
  const { input, size, quality, style } = this.promptStudio;
  this.promptStudio.preview = coerceToWorkingPrompt(
    `${input} | size:${size} | quality:${quality} | style:${style}`,
    this.bookTitle,
    { defaultSize: size, defaultQuality: quality, defaultStyle: style }
  );
},

pageClassForType(type, side) {
  if (/children|kids/i.test(type)) return `kids-page kids-${side}`;
  if (/comic/i.test(type)) return `comic-page comic-${side}`;
  return `story-page story-${side}`;
},
typographyForType(type) {
  if (/children|kids/i.test(type)) return 'kids-typography';
  if (/comic/i.test(type)) return 'comic-typography';
  return 'story-typography';
},
// Simple panel splitter: if ImageGrid, break into 2x2; else single panel
comicPanels(page) {
  if (Array.isArray(page.gridUrls) && page.gridUrls.some(Boolean)) {
    const imgs = page.gridUrls.filter(Boolean);
    const chunks = imgs.map((u, i) => ({ img: u, text: i === 0 ? (page.text || '') : '' }));
    return chunks.length ? chunks : [{ img: page.imageUrl || '', text: page.text || '' }];
  }
  return [{ img: page.imageUrl || '', text: page.text || '' }];
},
// === PATCH: exportPDF (fix html2canvas no-undef & remove unused startIndex) ===
async exportPDF() {
  try {
    if (!window.html2canvas) {
      await loadScript('https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js');
    }
    if (!window.jspdf) {
      await loadScript('https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js');
    }
    const { jsPDF } = window.jspdf;

    const pdf = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'letter', compress: true });
    const spreadEl = document.querySelector('.spread');
    if (!spreadEl) throw new Error('Viewer not open. Open the Book Viewer to export.');

    const addSpread = async () => {
      const h2c = window.html2canvas;
      if (!h2c) throw new Error('html2canvas failed to load');
      const canvas = await h2c(spreadEl, { backgroundColor: null, scale: 2, useCORS: true });
      const imgData = canvas.toDataURL('image/jpeg', 0.92);
      const pageW = pdf.internal.pageSize.getWidth();
      const pageH = pdf.internal.pageSize.getHeight();
      const ratio = Math.min(pageW / canvas.width, pageH / canvas.height);
      const w = canvas.width * ratio;
      const h = canvas.height * ratio;
      const x = (pageW - w) / 2;
      const y = (pageH - h) / 2;
      pdf.addImage(imgData, 'JPEG', x, y, w, h);
    };

    let idx = 0;
    const restore = this.currentPageIndex;

    for (idx = 0; idx < this.pages.length; idx += 2) {
      this.goToPage(idx);
      await this.$nextTick();
      if (idx > 0) pdf.addPage();
      await addSpread();
    }

    this.goToPage(restore);

    const fname = `${(this.bookTitle || 'book').replace(/\s+/g,'_')}.pdf`;
    pdf.save(fname);
    this.showNotification?.('PDF exported.', 'success');
  } catch (e) {
    console.error(e);
    this.showNotification?.(e.message || 'Failed to export PDF.', 'alert');
  }
},

    async shareProject() {
      const payload = {
        title: this.bookTitle,
        concept: this.concept,
        tableOfContents: this.tableOfContents,
        pages: this.pages
      };
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);

      if (navigator.share) {
        try {
          await navigator.share({
            title: this.bookTitle || 'Project',
            text: 'Check out my generated project.',
            url
          });
          this.showNotification?.('Shared.', 'success');
        } catch (e) {
          // user cancelled; ignore
        }
      } else {
        // fallback: copy URL
        await navigator.clipboard.writeText(url);
        this.showNotification?.('Share link copied to clipboard.', 'success');
      }
    },

async emailProject() {
  try {
    if (!window.html2canvas) {
      await loadScript('https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js');
    }
    const spreadEl = document.querySelector('.spread');
    const h2c = window.html2canvas;
    if (!h2c) throw new Error('html2canvas failed to load');
    const canvas = await h2c(spreadEl, { backgroundColor: null, scale: 2, useCORS: true });
    const imgData = canvas.toDataURL('image/png');

    const json = new Blob([JSON.stringify({
      title: this.bookTitle,
      concept: this.concept,
      tableOfContents: this.tableOfContents,
      pages: this.pages
    }, null, 2)], { type: 'application/json' });
    const jsonUrl = URL.createObjectURL(json);

    const subject = encodeURIComponent(`Project: ${this.bookTitle}`);
    const body = encodeURIComponent(
      `Hi,\n\nHere is my generated project. JSON link: ${jsonUrl}\n\n(Screenshot attached inline.)`
    );
    window.location.href = `mailto:?subject=${subject}&body=${body}`;

    // Optional clipboard image (only if supported)
    if (window.ClipboardItem && navigator.clipboard?.write) {
      try {
        const blob = await (await fetch(imgData)).blob();
        await navigator.clipboard.write([new window.ClipboardItem({ 'image/png': blob })]);
      } catch (_) { /* ignore clipboard errors */ }
    }
    this.showNotification?.('Email draft opened. (PNG copied to clipboard if supported.)', 'success');
  } catch (e) {
    this.showNotification?.('Could not open email with attachment. Copied project JSON link to clipboard.', 'alert');
    await navigator.clipboard.writeText(JSON.stringify({
      title: this.bookTitle,
      concept: this.concept,
      tableOfContents: this.tableOfContents,
      pages: this.pages
    }, null, 2)).catch(() => {});
  }
},
/* ====== IMAGE BATCH: generate all images after text is complete ====== */
async batchGenerateImages() {
  // Choose which pages to illustrate: all except pure TextOnly (you can include if you like)
  const targets = this.pages
  .map((p, i) => ({ i, p }))
  .filter(({ p }) =>
    this.projectType !== 'Script (No Images)' &&
    this.imageMode !== 'No Images' &&
    p && p.layout !== 'TextOnly'
  );

  this.imageBatch.isRunning = true;
  this._setImageBatchStatus({ current: 0, total: targets.length, status: 'Preparing images…' });
  this._startImageBatchTimer();
  this.showNotification?.(`Generating ${targets.length} page image(s)…`, 'alert');

  for (let k = 0; k < targets.length; k++) {
    const { i } = targets[k];
    this._setImageBatchStatus({ current: k, total: targets.length, status: `Rendering page ${i + 1}…` });

    try {
      await this.generatePageImage(i); // uses per-page status + spinner you already have
    } catch (err) {
      console.error('Batch image error (page', i + 1, '):', err);
      // keep going on failure
    }

    await delay(300); // slight cadence
  }

  this._setImageBatchStatus({ current: targets.length, total: targets.length, status: 'Images complete.' });
  this._stopImageBatchTimer();
  this.imageBatch.isRunning = false;
  this.readOutLoud('All images generated.');
  this.showNotification?.('All images generated.', 'success');
},

    /* ====== IMAGE GEN WRAPPER ====== */
 /* ====== IMAGE GEN WRAPPER (updated to use normalizeImageSize and clamp prompt) ====== */
async generateImage(params) {
  if (!this.gptApiKey) throw new Error("OpenAI API key missing.");

  const {
    prompt,
    size = "1024x1024",
    n = 1,
    quality = "standard",
    style = ""
  } = params || {};

  if (!prompt) throw new Error("Image prompt is required.");

  // Ensure prompt length is within API limits and keep inline directives
  const safePrompt = sanitizeAndShortenImagePrompt(prompt, 3600);
  // Use only supported sizes and coerce common near-misses (e.g., 1024x1536)
  const safeSize = normalizeImageSize(size);

  const fullPrompt = style ? `${safePrompt}\n\nStyle: ${style}` : safePrompt;

  try {
    const res = await axios.post(
      "https://api.openai.com/v1/images/generations",
      {
        model: "dall-e-3",
        prompt: fullPrompt,
        n,
        size: safeSize,
        quality,
        response_format: "url"
      },
      {
        headers: {
          Authorization: `Bearer ${this.gptApiKey}`,
          "Content-Type": "application/json"
        },
        timeout: 120000
      }
    );

    const urls = (res.data?.data || []).map(i => i?.url).filter(Boolean);
    if (!urls.length) throw new Error("Image generation returned no URLs.");
    return { urls, raw: res.data };
  } catch (err) {
    const msg = err?.response?.data?.error?.message || err?.message || String(err);
    throw new Error(`OpenAI image error: ${msg}`);
  }
},

    /* ====== SINGLE IMAGE FORM ====== */
// --- In your Vue SFC (MINOR change in image() before calling generateImage) ---
async image() {
  setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 4000);

  let basePrompt = "";
  if (this.selectedImageTypes?.includes("Custom Image") && this.customImagePrompt?.trim()) {
    basePrompt = this.customImagePrompt.trim();
  } else if (this.imagePrompt?.trim()) {
    basePrompt = this.imagePrompt.trim();
  } else {
    basePrompt = this.craftedImagePrompt;
  }

  // Coerce AFTER we have basePrompt
  basePrompt = coerceToWorkingPrompt(basePrompt, this.bookTitle);

  if (!basePrompt) {
    const msg = "Please enter a prompt for the image or select an image type.";
    alert(msg);
    this.showNotification?.(msg, "alert");
    return;
  }

  basePrompt = sanitizeAndShortenImagePrompt(basePrompt, 3800);

  window.scrollTo({ top: 1400, behavior: "smooth" });
  this.loading = true;
  try { 
    new Audio(submitAudio).play(); 
  } catch (err) { 
    console.debug('submitAudio play failed:', err); 
  }

  let seconds = 0;
  this.readOutLoud?.("Generating image...");
  this.showNotification?.("Generating Image....", "alert");
  const interval = setInterval(() => (this.loadingText = `Generating Image... (${++seconds}s)`), 1000);

  try {
    const { prompt, size, quality, n, style } = parseImageInput(basePrompt);
    const { urls } = await this.generateImage({
      prompt: sanitizeAndShortenImagePrompt(prompt, 3600),
      size, n, quality, style
    });

    this.generatedImageUrl = urls[0];
    this.generatedImageUrls = urls;
    this.imagePrompt = basePrompt;

    clearInterval(interval);
    this.loadingText = "";
    try { 
      new Audio(codeCompleteAudio).play(); 
    } catch (err) { 
      console.debug('codeCompleteAudio play failed:', err); 
    }
    const utterance = new SpeechSynthesisUtterance("Your image has been generated.");
    window.speechSynthesis.speak(utterance);
    this.showNotification?.("Your image has been generated.", "success");
  } catch (error) {
    console.error("Error generating image:", error);
    alert(error?.message || "There was an error generating the image.");
    clearInterval(interval);
    this.loadingText = "";
  } finally {
    this.loading = false;
  }
},

suggestSizeForLayout(layout) {
  // Allowed: 1024x1024 (square), 1024x1792 (portrait), 1792x1024 (landscape)
  switch ((layout || '').toLowerCase()) {
    case 'imageleft':
    case 'imageright':
    case 'imagegrid':
      return '1792x1024'; // wider
    case 'cover':
    case 'imagetop':
      return '1024x1792'; // taller
    default:
      return '1024x1024';
  }
},

// Build a scene prompt from the page's text + global context, with "no text/page numbers" guardrails.
buildPageImagePrompt(idx) {
  const p = this.pages[idx] || {};
  const raw = (p.text || '').toString();
  const scene = stripHtml(raw).split(/\s+/).slice(0, 300).join(' '); // ~120 words

  const title = (this.tableOfContents || '').split('\n')[0]?.trim() || 'Untitled';
  const genre = (this.genre || '').trim();
  const kws = String(this.keywords || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .slice(0, 6)
    .join(', ');

  const guardrails =
    'Do not include any text, numbers, page numbers, typography, watermarks, borders, or book mockups.';
  const size = this.suggestSizeForLayout(p.layout);

  // Use kws so it’s not unused; keep it compact
  const keywordsLine = kws ? ` Keywords: ${kws}.` : '';

  const composed =
    `Illustrate this scene from "${title}" (${genre}): ${scene}.${keywordsLine} ${guardrails} | size:${size} | quality:hd`;

  let directives = '';
  if (p.imagePrompt && p.imagePrompt.trim()) {
    const parts = p.imagePrompt.split('|').map(s => s.trim());
    parts.shift(); // drop old core text
    if (parts.length) directives = ' | ' + parts.join(' | ');
  }

  const finalPrompt = (composed + directives).replace(/\s+\|\s+/g, ' | ');
  return sanitizeAndShortenImagePrompt(finalPrompt, 3600);
},


    /* ====== PAGE / TEMPLATE HELPERS ====== */
    addBlankPage() {
  const page = {
    layout: this.globalLayout,
    text: '',
    imageUrl: '',
    gridUrls: ['', '', '', ''],
    imagePrompt: this.craftedImagePrompt,
    _loading: false,
    _status: '',
    _error: ''
  };
  this.pages.push(page);
},
    removePage(i) {
      this.pages.splice(i, 1);
    },
    movePage(i, dir) {
      const j = i + dir;
      if (j < 0 || j >= this.pages.length) return;
      const tmp = this.pages[i];
      this.$set(this.pages, i, this.pages[j]);
      this.$set(this.pages, j, tmp);
    },
    setPageLayout(i, layout) {
      const p = this.pages[i];
      p.layout = layout;
      if (layout === 'ImageGrid' && !Array.isArray(p.gridUrls)) {
        this.$set(this.pages[i], 'gridUrls', ['', '', '', '']);
      }
    },
    toggleLivePreview() {
      this.livePreview = !this.livePreview;
    },

// --- In your Vue SFC (MINOR change in generatePageImage() before parse + API) ---
async generatePageImage(idx) {
  const p = this.pages[idx];
  if (!p) return;

  if (this.imageMode === 'No Images') {
    this.showNotification?.('Image mode is set to “No Images”.', 'alert');
    return;
  }

  // Build base then coerce
  let basePrompt = this.buildPageImagePrompt(idx);
  basePrompt = coerceToWorkingPrompt(basePrompt, this.bookTitle);

  if (!basePrompt) {
    const msg = 'This page has no text yet to illustrate. Please add some story text.';
    alert(msg);
    this.showNotification?.(msg, 'alert');
    return;
  }

  basePrompt = sanitizeAndShortenImagePrompt(basePrompt, 3800);

  this.$set(p, '_loading', true);
  this.$set(p, '_error', '');
  this.$set(p, '_status', 'Generating image...');
try {
  new Audio(submitAudio).play();
} catch (err) {
  // Non-fatal: audio may be blocked by autoplay policy
  console.debug('submitAudio play failed:', err);
}

  let seconds = 0;
  const interval = setInterval(() => {
    this.$set(p, '_status', `Generating image... (${++seconds}s)`);
  }, 1000);

  try {
    let { prompt, size, quality, n, style } = parseImageInput(basePrompt);
    if (!size) size = this.suggestSizeForLayout(p.layout);

    const { urls } = await this.generateImage({
      prompt: sanitizeAndShortenImagePrompt(prompt, 3600),
      size, n, quality, style
    });
    if (!urls || !urls.length) throw new Error('Image generation returned no URLs.');

    if (p.layout === 'ImageGrid') {
      const grid = Array.isArray(p.gridUrls) ? [...p.gridUrls] : ['', '', '', ''];
      const take = Math.min(4, urls.length);
      for (let i = 0; i < take; i++) grid[i] = urls[i];
      this.$set(p, 'gridUrls', grid);
    } else {
      this.$set(p, 'imageUrl', urls[0]);
    }

    this.$set(p, 'imagePrompt', basePrompt);

    try {
      new Audio(codeCompleteAudio).play();
      const utterance = new SpeechSynthesisUtterance(`Page ${idx + 1} image generated.`);
      window.speechSynthesis.speak(utterance);
} catch (err) {
  // Intentionally ignore but keep non-empty for linting
  console.debug('Non-fatal error ignored:', err);
}

    this.showNotification?.(`Page ${idx + 1} image generated.`, 'success');
  } catch (error) {
    const msg = error?.message || 'There was an error generating the page image.';
    console.error('Error generating page image:', error);
    this.$set(p, '_error', msg);
    this.showNotification?.(msg, 'alert');
  } finally {
    clearInterval(interval);
    this.$set(p, '_loading', false);
    this.$set(p, '_status', '');
  }
},
    /* ====== TEXT TRANSFORMS ====== */
    htmlToPlainText(htmlContent) {
      return htmlContent
        .replace(/<h4>/g, '')
        .replace(/<\/h4>/g, '\n')
        .replace(/<p>/g, '')
        .replace(/<\/p>/g, '\n\n')
        .replace(/<br\/>/g, '\n')
        .replace(/<br>/g, '\n')
        .trim();
    },
    toKidFriendly(text) {
      const sentences = text.split(/\.\s+/).map(s => s.trim()).filter(Boolean);
      const simplified = sentences.map(s => {
        s = s.replace(/however|therefore|moreover|nevertheless/gi, 'and');
        s = s.replace(/\butilize\b/gi, 'use');
        return s;
      });
      return simplified.join('. ') + (simplified.length ? '.' : '');
    },
    toScreenplay(text) {
      const lines = text.split(/\n+/).map(l => l.trim()).filter(Boolean);
      const mapped = lines.map((l, i) => {
        if (i % 7 === 0) return `INT. PLACE - DAY\n${l}`;
        if (i % 5 === 0) return `EXT. PLACE - NIGHT\n${l}`;
        if (i % 3 === 0) return `CHARACTER:\n${l}`;
        return l;
      });
      return mapped.join('\n\n');
    },

    splitIntoPages(text, targetPages) {
      const paragraphs = text.split(/\n{2,}/).map(p => p.trim()).filter(Boolean);
      const pages = [];
      const chunkSize = Math.ceil(paragraphs.length / Math.max(1, targetPages));
      for (let i = 0; i < paragraphs.length; i += chunkSize) {
        pages.push(paragraphs.slice(i, i + chunkSize).join('\n\n'));
      }
      while (pages.length < targetPages) pages.push('');
      return pages.slice(0, targetPages);
    },

    /* ====== PIPELINE: CORE GENERATION ====== */
    async activateGenerativeAIProcess() {
      this.readOutLoud("Activating Cognitive A I.");
      this.loadingText = "Preparing AI...";
      this.showImageOverlay = true;
      await delay(5000);
      setTimeout(() => {
        this.showImageOverlay = false;
        this.readOutLoud("AI has been activated on this project.");
        this.loading = false;
      }, 4500);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 2000);
      this.loading = false;
    },
    _bookKeyNav(e) {
    if (!this.showBookViewer) return;
    if (e.key === 'ArrowRight') this.nextPage();
    if (e.key === 'ArrowLeft') this.prevPage();
  },

_refreshProjects() {
    try { this.projects = JSON.parse(localStorage.getItem('savedBooks') || '[]'); }
    catch { this.projects = []; }
  },
  _saveProjectsList() {
    localStorage.setItem('savedBooks', JSON.stringify(this.projects));
  },

saveProject() {
  // keep current ID (update existing), otherwise create a new one
  const id = this.currentProjectId || `book_${Date.now()}_${Math.random().toString(36).slice(2,7)}`;

  const payload = {
    id,
    title: this.bookTitle,            // uses projectTitle first
    savedAt: Date.now(),
    concept: this.concept,
    tableOfContents: this.tableOfContents,
    chaptersHtml: this.chaptersHtml,
    imageMode: this.imageMode,
    projectType: this.projectType,
    pageCount: this.pageCount,
    globalLayout: this.globalLayout,
    genre: this.genre,
    keywords: this.keywords,
    gptRole: this.gptRole,
    savedImages: this.savedImages.slice(0), // optional
    pages: this.pages.map(p => ({
      layout: p.layout,
      text: p.text,
      imageUrl: p.imageUrl || '',
      gridUrls: Array.isArray(p.gridUrls) ? p.gridUrls : [],
      imagePrompt: p.imagePrompt || ''
    }))
  };

  const idx = this.projects.findIndex(p => p.id === id);
  if (idx >= 0) this.projects.splice(idx, 1, payload);
  else this.projects.push(payload);

  this._saveProjectsList();
  this.currentProjectId = id;            // continue updating this project
  this.showNotification?.('Project saved.', 'success');
},

saveProjectAsCopy() {
  const id = `book_${Date.now()}_${Math.random().toString(36).slice(2,7)}`;
  const payload = {
    id,
    title: this.bookTitle,         // uses projectTitle first
    savedAt: Date.now(),
    concept: this.concept,
    tableOfContents: this.tableOfContents,
    chaptersHtml: this.chaptersHtml,
    imageMode: this.imageMode,
    projectType: this.projectType,
    pageCount: this.pageCount,
    globalLayout: this.globalLayout,
    genre: this.genre,
    keywords: this.keywords,
    gptRole: this.gptRole,
    pages: this.pages.map(p => ({
      layout: p.layout,
      text: p.text,
      imageUrl: p.imageUrl || '',
      gridUrls: Array.isArray(p.gridUrls) ? p.gridUrls : [],
      imagePrompt: p.imagePrompt || ''
    }))
  };

  this.projects.push(payload);
  this._saveProjectsList();
  this.currentProjectId = id;     // now editing the copy
  this.showNotification?.('Saved as a new copy.', 'success');
},

loadProject(id) {
  const proj = this.projects.find(p => p.id === id);
  if (!proj) {
    this.showNotification?.('Project not found.', 'alert');
    return;
  }
  this.savedImages = Array.isArray(proj.savedImages) ? proj.savedImages : this.savedImages;
  this.currentProjectId = id;                     // <-- ensure current points to loaded
  this.projectTitle = proj.title || '';           // <-- NEW: hydrate title
  this.concept = proj.concept || '';
  this.tableOfContents = proj.tableOfContents || '';
  this.chaptersHtml = proj.chaptersHtml || '';
  this.imageMode = proj.imageMode || this.imageMode;
  this.projectType = proj.projectType || this.projectType;
  this.pageCount = proj.pageCount || this.pageCount;
  this.globalLayout = proj.globalLayout || this.globalLayout;
  this.genre = proj.genre || this.genre;
  this.keywords = proj.keywords || this.keywords;
  this.gptRole = proj.gptRole || this.gptRole;
  this.pages = (proj.pages || []).map(p => ({
    layout: p.layout,
    text: p.text,
    imageUrl: p.imageUrl,
    gridUrls: p.gridUrls || ['', '', '', ''],
    imagePrompt: p.imagePrompt || this.craftedImagePrompt,
    _loading: false, _status: '', _error: ''
  }));
  this.showNotification?.('Project loaded.', 'success');
},

deleteProject(id) {
  if (!id) return;
  const idx = this.projects.findIndex(p => p.id === id);
  if (idx >= 0) {
    this.projects.splice(idx, 1);
    this._saveProjectsList();
    if (this.currentProjectId === id) {
      this.currentProjectId = null;
      this.projectTitle = ''; // clear title if you deleted current
    }
    this.showNotification?.('Project deleted.', 'alert');
  }
},


  downloadBookJson() {
    const obj = {
      title: this.bookTitle,
      savedAt: Date.now(),
      concept: this.concept,
      tableOfContents: this.tableOfContents,
      chaptersHtml: this.chaptersHtml,
      pages: this.pages
    };
    const blob = new Blob([JSON.stringify(obj, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = `${(this.bookTitle || 'book').replace(/\s+/g,'_')}.json`;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(url);
    a.remove();
  },

  openBookViewer(startAt = 0) {
    this.currentPageIndex = Math.max(0, Math.min(startAt, Math.max(0, this.pages.length - 1)));
    this.showBookViewer = true;
  },
  closeBookViewer() { this.showBookViewer = false; },
  nextPage() { this.currentPageIndex = Math.min(this.currentPageIndex + 2, Math.max(0, this.pages.length - 1)); },
  prevPage() { this.currentPageIndex = Math.max(this.currentPageIndex - 2, 0); },
  goToPage(i) { this.currentPageIndex = Math.max(0, Math.min(i % 2 === 0 ? i : i - 1, Math.max(0, this.pages.length - 1))); },

  isCover(i) { return i === 0; },
    startTimer(duration = 10) {
      this.showTimer = true;
      this.timeLeft = duration;
      this.statusMessage = "Running…";
      const timerInterval = setInterval(() => {
        this.timeLeft--;
        this.timeLeftPercentage = (this.timeLeft / duration) * 100;
        if (this.timeLeft <= 0) {
          clearInterval(timerInterval);
          this.showTimer = false;
          this.statusMessage = "";
        }
      }, 1000);
    },
    scrollToElement(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },

    async generateConcept() {
      await this.activateGenerativeAIProcess();
      this.showTimer = true;
      this.startTimer(8);
      await delay(1000);
      setTimeout(() => {
        this.currentStep = 1;
        this.readOutLoud("Generating Concept...");
        this.showNotification("Generating Concept...", "alert");
      }, 500);
      new Audio(submitAudio).play();
      const concept = await generateConcept({
        gptRole: this.gptRole,
        bookLength: this.bookLength,
        genre: this.genre,
        keywords: this.keywords.split(',')
      });
      this.concept = concept;
      this.$nextTick(() => {
        this.scrollToElement('book-concept');
      });
      this.automatedGenerationProcess();
      this.readOutLoud("Concept generated successfully");
      this.showNotification("Concept generated successfully.", "alert");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 800);
      new Audio(codeCompleteAudio).play();
    },

    async generateTableOfContents() {
      const contents = await generateTableOfContents({
        gptRole: this.gptRole,
        genre: this.genre,
        keywords: this.keywords.split(','),
        concept: this.concept
      });
      this.tableOfContents = contents;
      this.$nextTick(() => {
        this.scrollToElement('table-of-contents');
      });
      this.readOutLoud("Table of Contents generated successfully");
      this.showNotification("Table of Contents generated successfully.", "alert");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 800);
      new Audio(codeCompleteAudio).play();
    },

    async generateChapters() {
      const chapters = await generateChapters({
        gptRole: this.gptRole,
        genre: this.genre,
        keywords: this.keywords.split(','),
        tableOfContents: this.tableOfContents,
        autoGen: this.autoGenerateChapters
      });

      this.chaptersHtml = this.htmlToPlainText(
        chapters
          .map(chapter => `<h4>${chapter.title}</h4><p>${chapter.content.replace(/\n/g, '<br/>')}</p>`)
          .join('')
      );

      this.$forceUpdate();
      this.$nextTick(() => {
        this.scrollToElement('chapters');
      });

      this.readOutLoud("Chapters generated successfully");
      this.showNotification("Chapters generated successfully.", "alert");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 800);
      new Audio(codeCompleteAudio).play();
    },

    exportToTxtMethod() {
      exportToTxt(this.chaptersHtml);
    },

    async generateChaptersAndImages() {
      await this.generateChapters();
    },
    /* ====== ORCHESTRATOR: Concept → TOC → Chapters → Pages → Images ====== */
async runFullPipeline() {
  try {
    // Prep UI
    this.currentStep = 0;
    this.showImageOverlay = true;
    this.loadingText = 'Initializing…';
    this.readOutLoud('Starting full project generation.');

    // Concept
    this.currentStep = 1;
    this.loadingText = 'Generating concept…';
    await this.generateConcept();

    // TOC
    this.currentStep = 2;
    this.loadingText = 'Generating table of contents…';
    await this.generateTableOfContents();

    // Chapters
    this.currentStep = 3;
    this.loadingText = 'Generating chapters…';
    await this.generateChapters();

    // Pages (NO images yet)
    this.loadingText = 'Building pages…';
    await this.generateProject({ withImages: false });

    // Batch images with global timer
    this.currentStep = 4;
    this.loadingText = 'Generating images…';
    await this.batchGenerateImages();

    // Done
this.currentStep = 5;
this.loadingText = '';
this.showImageOverlay = false;
this.readOutLoud('Your project is complete.');
new Audio(codeCompleteAudio).play();

// ✅ Auto-save and open the flip viewer
this.saveProject();
this.openBookViewer(0);
  } catch (err) {
    console.error('Full pipeline error:', err);
    this.showNotification?.(err?.message || 'An error occurred during generation.', 'alert');
    this.showImageOverlay = false;
  }
},

    async automatedGenerationProcess() {
      try {
        this.currentStep = 2;
        this.automatedNextStep(this.generateTableOfContents);
      } catch (error) {
        console.error("Error in automated generation process:", error);
      }
    },

    automatedNextStep(nextFunction) {
      setTimeout(async () => {
        try {
          await nextFunction.call(this);
          switch (this.currentStep) {
            case 2:
              this.currentStep = 3;
              this.automatedNextStep(this.generateChapters);
              break;
            case 3:
              this.currentStep = 4;
              this.automatedNextStep(this.image);
              break;
            case 4:
              setTimeout(() => {
                this.currentStep = 5;
              }, 400);
              this.closeLightbox();
              setTimeout(() => {
                this.saveImage();
                this.celebrateCompletion();
              }, 500);
              setTimeout(() => {
                this.readOutLoud("Congratulations, your project is complete!");
                this.celebrateCompletion();
              }, 900);
              break;
          }
        } catch (error) {
          console.error("Error in automated next step:", error);
        }
      }, 800);
    },

    celebrateCompletion() {
      this.currentStep = 5;
      this.triggerCelebrationEffect();
    },
    triggerCelebrationEffect() {
      if (this.confetti && typeof this.confetti.start === 'function') {
        this.confetti.start();
      }
    },

/* ====== NEW: PROJECT GENERATION (Realtime Pages) ====== */
async generateProject(opts = {}) {
  const withImages = opts.withImages !== false; // default true for manual usage

  this.pages = [];
  if (!this.chaptersHtml?.trim()) {
    await this.generateConcept();
    await this.generateTableOfContents();
    await this.generateChapters();
  }

  let text = this.chaptersHtml || '';
  if (this.projectType === 'Script (No Images)') {
    text = this.toScreenplay(text);
  } else if (this.projectType === 'Kids (Images))') {
    text = this.toKidFriendly(text);
  }

  /* Decide page count */
  let targetPages = this.pageCount || 8;
  if (this.projectType === 'Short (5–10 pages)') {
    targetPages = Math.max(5, Math.min(10, targetPages));
  }

  const pageTexts = this.splitIntoPages(text, targetPages);

  /* Cover page */
  const cover = {
    layout: 'Cover',
    text: (this.tableOfContents || '').split('\n')[0]?.trim() || 'Untitled',
    imageUrl: '',
    gridUrls: ['', '', '', ''],
    imagePrompt: this.craftedImagePrompt,
    _loading: false, _status: '', _error: ''
  };
  this.pages.push(cover);

  /* Generate subsequent pages one by one (live) */
  for (let i = 0; i < pageTexts.length; i++) {
    const bodyLayout = this.globalLayout;
    const page = {
      layout: bodyLayout,
      text: pageTexts[i],
      imageUrl: '',
      gridUrls: ['', '', '', ''],
      imagePrompt: generateImagePrompt({
        title: `Page ${i + 1}`,
        genre: this.genre || 'fiction',
        keywords: String(this.keywords || '').split(',').map(s => s.trim()).filter(Boolean),
        concept: this.concept || ''
      }),
      _loading: false, _status: '', _error: ''
    };
    this.pages.push(page);

    // Only generate images here if explicitly allowed
    if (withImages && this.projectType !== 'Script (No Images)' && this.imageMode === 'Auto (Per Page)') {
      try {
        await this.generatePageImage(this.pages.length - 1);
      } catch (e) {
        console.warn('Image failed for page', i + 1, e);
      }
    }

    await delay(250); // small visual delay
  }

  // Cover image last (only if withImages)
  if (withImages && this.projectType !== 'Script (No Images)' && this.imageMode !== 'No Images') {
    try {
      await this.generatePageImage(0);
    } catch (e) {
      console.warn('Cover image failed', e);
    }
  }

  this.readOutLoud('Project generated. Showing live template preview.');
  this.livePreview = true;
},


    /* ====== VOICE / RECORDING ====== */
    promptUserAndStartRecording() {
      this.readOutLoud('What do you want to create?');
      setTimeout(() => {
        this.isRecording = true;
        this.recordingStateColor = 'green';
        this.startRecording();
      }, 2000);
    },
    promptUserAndStartRecordingGen() {
      this.readOutLoud('What is the book length?');
      setTimeout(() => {
        this.isRecording = true;
        this.recordingStateColor = 'green';
        this.startRecording();
      }, 2000);
    },
startRecording() {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SpeechRecognition) {
    this.showNotification?.('Speech recognition not supported in this browser.', 'alert');
    return;
  }
  this.recognition = new SpeechRecognition();
  this.recognition.lang = 'en-US';
  this.recognition.start();

  this.recognition.onstart = () => {
    this.recordingStateColor = 'blue';
    this.isRecording = true;
  };

  this.recognition.onresult = (event) => {
    this.imagePrompt = event.results[0][0].transcript;
    this.recordingStateColor = 'red';
    setTimeout(async () => {
      await this.image(); // instead of generateImage(params)
      this.stopRecording();
    }, 1000);
  };

  this.recognition.onerror = () => {
    this.stopRecording();
  };
},
stopRecording() {
  if (this.recognition) {
    this.recognition.stop();
    this.recognition = null;
  }
  this.isRecording = false;
  this.recordingStateColor = 'blue';
},

    /* ====== SAVED IMAGES / LIGHTBOX ====== */
    showNotification(message, type) {
      if (this.$refs.notifications && this.$refs.notifications.addNotification) {
        this.$refs.notifications.addNotification(message, type);
      }
    },
    createDownloadableImage(imageUrl) {
      const canvas = document.createElement('canvas');
      this.generatedImageUrl = canvas.toDataURL('image/png');
      this.generatedImageUrl = imageUrl;
    },
    saveImage() {
      const imageToSave = {
        type: 'image',
        prompt: this.imagePrompt,
        url: this.generatedImageUrl
      };

      if (this.editingImageIndex === -1) {
        this.savedImages.push(imageToSave);
        localStorage.setItem("savedImages", JSON.stringify(this.savedImages));
      } else {
        this.$set(this.savedImages, this.editingImageIndex, imageToSave);
        this.editingImageIndex = -1;
      }

      localStorage.setItem("savedImages", JSON.stringify(this.savedImages));
    },
    updateImage() {
      if (this.editingImageIndex !== -1) {
        const updatedImage = {
          prompt: this.imagePrompt,
          url: this.generatedImageUrl
        };

        this.$set(this.savedImages, this.editingImageIndex, updatedImage);
        this.editingImageIndex = -1;
        localStorage.setItem("savedImages", JSON.stringify(this.savedImages));
      }
    },
    editSavedImage(index) {
      const savedImage = this.savedImages[index];
      this.imagePrompt = savedImage.prompt;
      this.generatedImageUrl = savedImage.url;
      this.editingImageIndex = index;
    },
    deleteSavedImage(index) {
      this.savedImages.splice(index, 1);
      localStorage.setItem("savedImages", JSON.stringify(this.savedImages));
    },
openLightbox(image, index) {
    this.lightboxImage = image;
    this.lightboxIndex = index;
    this.isLightboxOpen = true;
    this.$nextTick(() => {
      const el = document.querySelector('.lightbox-overlay');
      if (el) el.focus(); // so Esc works immediately
    });
  },
  closeLightbox() {
    this.isLightboxOpen = false;
    this.lightboxImage = null;
    this.lightboxIndex = null;
  },

    /* ====== IMAGE EDITOR ====== */
    openImageEditor() {
      this.imageEditorOpen = true;
      this.canvas = new fabric.Canvas('canvas');
    },
    addRectangle() {
      const rect = new fabric.Rect({
        left: 100,
        top: 100,
        fill: 'red',
        width: 60,
        height: 70,
        angle: 45
      });
      this.canvas.add(rect);
    },
    addCircle() {
      const circle = new fabric.Circle({
        radius: 20, fill: 'green', left: 100, top: 100
      });
      this.canvas.add(circle);
    },
    addText() {
      const text = new fabric.IText('Hello world', {
        left: 100,
        top: 100,
        fontFamily: 'Arial',
        fill: '#333',
        fontSize: 20
      });
      this.canvas.add(text);
    },
    saveEditedImage() {
      this.editedImageUrl = this.canvas.toDataURL();
      this.closeImageEditor();
    },
    downloadEditedImage() {
      const link = document.createElement('a');
      link.href = this.editedImageUrl;
      link.download = 'edited-image.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    closeImageEditor() {
      this.imageEditorOpen = false;
    },

    /* ====== VOICES ====== */
    initSpeechSynthesis() {
      speechSynthesis.onvoiceschanged = () => {
        this.availableVoices = speechSynthesis.getVoices();
        this.voiceOptions = this.availableVoices
          .filter(voice => this.preferredVoices.includes(voice.name))
          .map(voice => ({ label: voice.name, value: voice.name }));
        if (this.voiceOptions.length > 0) {
          this.selectedVoiceName = this.voiceOptions[0].value;
        }
      };
    },
    updateSelectedVoice(voiceName) {
      this.selectedVoiceName = voiceName;
      const selectedVoice = this.availableVoices.find(voice => voice.name === voiceName);
      if (selectedVoice) {
        this.speechSynthesisUtterance.voice = selectedVoice;
      }
    }
  }
};
</script>
<style scoped>
/* ===============================
   TOURISTIC AI ASSISTANT THEME
   Glass + Neon + Grid + Motion
   =============================== */
:root {
  --bg-0: #0c161b;
  --bg-1: rgba(12,22,27,0.65);
  --glass: rgba(255,255,255,0.08);
  --glass-2: rgba(255,255,255,0.12);
  --ink: #e9f5ff;
  --ink-dim: #a9c1cc;
  --accent: #42da91;
  --accent-2: #78cce2;
  --warn: #ffb86b;
  --danger: #ff5d73;
}
/* Subtle elevation + larger labels for this row */
.neon-form-row { margin-top: 2px; }

.form-elevated .v-input__slot {
  border-radius: 18px !important;
  box-shadow: 0 10px 24px rgba(0,0,0,0.28), inset 0 0 0 1px rgba(255,255,255,0.05);
  transition: transform .15s ease, box-shadow .25s ease, border-color .25s ease;
}
.form-elevated .v-input__slot:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(0,0,0,0.34), 0 0 0 1px rgba(66,218,145,0.2) inset;
}
.form-elevated .v-input__slot:focus-within {
  box-shadow:
    0 0 0 2px rgba(66,218,145,0.35),
    0 16px 32px rgba(0,0,0,0.38),
    inset 0 0 0 1px rgba(255,255,255,0.08);
}
.form-elevated .v-label {
  font-size: 1.02rem !important;
  font-weight: 600;
  letter-spacing: .015em;
}
/* Glassy dropdown menu surface */
.menu-glass {
  backdrop-filter: blur(10px);
  background: linear-gradient(180deg, rgba(20,32,38,0.92), rgba(20,32,38,0.86)) !important;
  border: 1px solid rgba(255,255,255,0.10) !important;
  box-shadow: 0 16px 40px rgba(0,0,0,0.45);
  border-radius: 14px !important;
}
/* ---------- Overlay / loading ---------- */
.overlay {
  position: fixed; inset: 0;
  display: grid; place-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
.animated-image { transform: scale(0); animation: scaleIn .5s forwards, fadeOut .5s 5s forwards; }
@keyframes scaleIn { to { transform: scale(1) } }
@keyframes fadeOut { to { opacity: 0 } }

.loading-container {
  background: rgba(12, 22, 27, 0.5);
  border: 1px solid rgba(120,204,226,0.22);
  color: var(--ink);
  padding: 12px 14px;
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(0,0,0,0.35);
  text-align: center;
  font-size: 1.05rem;
}

/* ---------- Ambient backdrop (subtle animated stars/dots) ---------- */
.bg-content {
  position: relative;
  background:
    radial-gradient(1500px 600px at 80% -20%, rgba(66,218,145,0.15), transparent 60%),
    radial-gradient(1200px 500px at -10% 120%, rgba(120,204,226,0.12), transparent 60%),
    linear-gradient(180deg, rgba(12,22,27,0.85), rgba(12,22,27,0.95));
  overflow: hidden;
}
.bg-content::after {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(rgba(255,255,255,0.12) 1px, transparent 1px),
    radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px);
  background-size: 24px 24px, 48px 48px;
  background-position: 0 0, 12px 12px;
  opacity: .15;
  animation: drift 30s linear infinite;
  pointer-events: none;
}
@keyframes drift { 0% { transform: translateY(0) } 100% { transform: translateY(-60px) } }

/* ---------- Card shells ---------- */
.book-generator {
  color: var(--ink);
  border-radius: 22px;

  background:
    linear-gradient(180deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02)) padding-box,
    conic-gradient(from 180deg at 50% 50%, rgba(66,218,145,0.25), rgba(120,204,226,0.25), rgba(66,218,145,0.25)) border-box;
  backdrop-filter: blur(12px);
  box-shadow: 0 18px 30px rgba(0,0,0,0.4), inset 0 0 0 1px rgba(255,255,255,0.03);
  animation: subtleFloat 8s ease-in-out infinite;
  max-width: 100%;
  margin: 20px auto;
  padding: 20px;
}
@keyframes subtleFloat { 0%,100% { transform: translateY(0) } 50% { transform: translateY(-2px) } }

/* ---------- Dashboard Grid (auto fits preview cards) ---------- */
.book-generator .v-card-text > .v-layout[row][wrap] {
  display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(300px, 0.5fr));
  grid-gap: 18px;
}
.page-card {
  position: relative;
  min-height: 380px;
  border-radius: 18px;
  background: rgba(255,255,255,0);
  border: 1px solid rgba(255,255,255,0.08);
  overflow: hidden;
  transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
}
.page-card:hover {
  transform: translateY(-3px);
  border-color: rgba(66,218,145,0.35);
  box-shadow: 0 18px 25px rgba(0,0,0,0.45), 0 0 0 1px rgba(66,218,145,0.18) inset;
}
.page-card::before {
  content: "";
  position: absolute; inset: -1px;
  border-radius: inherit;
  background:
    radial-gradient(600px 180px at 20% 0%, rgba(66,218,145,0.15), transparent),
    radial-gradient(600px 180px at 80% 100%, rgba(120,204,226,0.12), transparent);
  pointer-events: none;
}

/* ---------- Page header row ---------- */
.page-card .page-header {
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px dashed rgba(255,255,255,0.08);
}
.page-card .page-header .caption { color: var(--ink-dim); }

/* ---------- Image regions ---------- */
.page-image {
  width: 100%;
  border-radius: 14px;
  overflow: hidden;
  background: rgba(0,0,0,0.22);
  border: 1px solid rgba(255,255,255,0.07);
  box-shadow: inset 0 0 0 1px rgba(255,255,255,0.02);
}
.page-image img {
  display: block;
  width: 100%;
  height: 280px;
  object-fit: cover;
  transition: transform .45s ease;
}
.page-card:hover .page-image img { transform: scale(1.02) }

/* ---------- Side-by-side text/image ---------- */
.layout-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 960px) {
  .layout-row { grid-template-columns: 1fr; }
  .page-image img { height: 220px; }
}

/* ---------- Text areas in page ---------- */
.page-text :deep(textarea),
.page-text .v-input__slot { background: var(--glass) !important; }
.page-text :deep(textarea) {
  color: var(--ink) !important;
  line-height: 1.55;
  font-size: 15px;
}
.page-text { min-height: 280px; border-radius: 14px; }

/* ---------- 2×2 image grid ---------- */
.grid-2 { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; }
.grid-cell {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: rgba(0,0,0,0.25);
  border: 1px solid rgba(255,255,255,0.07);
  aspect-ratio: 1 / 1;
}
.grid-cell img { width: 100%; height: 100%; object-fit: cover; }
.grid-placeholder {
  position: absolute; inset: 0; display: grid; place-items: center;
  color: var(--ink-dim); font-size: 12px; letter-spacing: .02em;
}

/* ---------- Tri-panel editors: Concept / TOC / Chapters ---------- */
.textarea-height :deep(textarea) {
  min-height: 260px; max-height: 60vh; overflow: auto;
  background: var(--glass) !important;
  color: var(--ink) !important;
  border-radius: 14px !important;
}
.textarea-height .v-input__slot {
  border: 1px solid rgba(255,255,255,0.08) !important;
  box-shadow: inset 0 6px 16px rgba(0,0,0,0.25);
}
.textarea-height .v-label { color: var(--ink-dim) !important; }
.v-layout.row.wrap > .v-flex .v-textarea { display: flex; flex-direction: column; }
.v-layout.row.wrap > .v-flex .v-textarea .v-input__control { flex: 1 1 auto; }

/* ---------- Stepper (neon) ---------- */
.stepper-flex {
  --mouseX: 50vh; --mouseY: 50vw;
  width: 280px; border-radius: 16px;
  background: linear-gradient(180deg, var(--glass), rgba(255,255,255,0.04));
}
.stepper-flex:hover {
  animation: glow 1600ms ease-out infinite alternate;
  border-color: var(--accent);
  box-shadow: 0 0 12px rgba(120, 204, 226, 0.25), inset 0 0 10px rgba(66,218,145,0.55);
  transform: translateY(-2px);
}
@keyframes glow {
  0% { box-shadow: 0 0 8px rgba(66,218,145,0.25) }
  100% { box-shadow: 0 0 16px rgba(120,204,226,0.35) }
}
.page-pre {
  background:
    radial-gradient(600px 200px at var(--mouseX) var(--mouseY), rgba(120,204,226,0.12), transparent 60%),
    radial-gradient(600px 200px at calc(100% - var(--mouseX)) calc(100% - var(--mouseY)), rgba(66,218,145,0.15), transparent 60%);
}
.v-stepper .v-stepper-step__step {
  background-color: rgba(255,255,255,0.5);
  color: #fff;
  border: 2px solid rgba(255,255,255,0.75);
  transition: all .25s ease;
}
.v-stepper .v-stepper-step__step:hover { transform: scale(1.06) }
.v-stepper-content { color: var(--ink) }

/* ---------- Inputs / selects (enhanced) ---------- */
.custom-text-field .v-input__control .v-input__slot,
.custom-select-field .v-input__slot {
  background:
    linear-gradient(180deg, rgba(255,255,255,0.10), rgba(255,255,255,0.06)) !important;
  padding-block: 16px;
  padding-inline: 14px;
  border: 1px solid rgba(255,255,255,0.16) !important;
  border-radius: 16px !important;
  transition: border-color .25s ease, box-shadow .25s ease, background-color .25s ease, transform .15s ease;
  box-shadow: 0 6px 18px rgba(0,0,0,0.28), inset 0 0 0 1px rgba(255,255,255,0.04);
  will-change: box-shadow, transform;
}
/* Larger text + better contrast */
.custom-text-field input,
.custom-select-field input,
.custom-select-field .v-select__selection--comma,
.custom-select-field .v-select__selection--comma .v-chip__content,
.custom-select-field .v-select__selections {
  color: var(--ink) !important;
  font-size: 17px;
  line-height: 1.5;
  caret-color: var(--accent);
}
/* Placeholder + label polish */
.custom-text-field input::placeholder,
.custom-select-field input::placeholder { color: rgba(233,245,255,0.55); }
.custom-text-field .v-label,
.custom-select-field .v-label {
  color: rgba(233,245,255,0.75) !important;
  font-size: 0.95rem;
  letter-spacing: .02em;
}
/* Icons color alignment */
.custom-select-field .v-select__slot,
.custom-select-field .v-input__append-inner,
.custom-text-field .v-input__append-inner {
  color: var(--ink) !important;
  opacity: .9;
}
/* Hover: subtle lift + brighter rim */
.custom-text-field .v-input__control .v-input__slot:hover,
.custom-select-field .v-input__slot:hover {
  border-color: rgba(120,204,226,0.45) !important;
  box-shadow: 0 10px 24px rgba(0,0,0,0.34), 0 0 0 1px rgba(66,218,145,0.25) inset;
  transform: translateY(-1px);
}
/* Focus ring animation */
@keyframes focus-glow {
  0%   { box-shadow: 0 0 0 0 rgba(66,218,145,0.0), 0 0 0 0 rgba(120,204,226,0.0) }
  50%  { box-shadow: 0 0 0 3px rgba(66,218,145,0.20), 0 0 20px 0 rgba(120,204,226,0.18) }
  100% { box-shadow: 0 0 0 0 rgba(66,218,145,0.0), 0 0 0 0 rgba(120,204,226,0.0) }
}
/* Focus-within: neon outline + animated glow */
.custom-text-field .v-input__control .v-input__slot:focus-within,
.custom-select-field .v-input__slot:focus-within {
  border-color: var(--accent) !important;
  box-shadow: 0 0 0 2px rgba(66,218,145,0.35), 0 10px 26px rgba(0,0,0,0.36), inset 0 0 0 1px rgba(255,255,255,0.08);
  animation: focus-glow 1.2s ease-out;
}
/* Chips inside selects (multi) */
.custom-select-field .v-chip {
  background: rgba(120,204,226,0.20) !important;
  color: var(--ink);
  border: 1px solid rgba(120,204,226,0.35);
  border-radius: 12px;
  height: 28px;
  margin: 2px 4px;
}
/* Disabled state */
.custom-text-field .v-input--is-disabled .v-input__slot,
.custom-select-field .v-input--is-disabled .v-input__slot {
  opacity: .65; filter: grayscale(10%); cursor: not-allowed;
}
/* Error state: clearer border + shake micro-animation */
@keyframes micro-shake {
  0%,100% { transform: translateX(0) }
  25%     { transform: translateX(-1px) }
  75%     { transform: translateX(1px) }
}
.custom-text-field .error--text ~ .v-input__control .v-input__slot,
.custom-select-field .error--text ~ .v-input__slot,
.custom-text-field .v-input.error--text .v-input__slot,
.custom-select-field .v-input.error--text .v-input__slot {
  border-color: rgba(255,93,115,0.85) !important;
  box-shadow: 0 0 0 2px rgba(255,93,115,0.28);
  animation: micro-shake .18s ease-in-out 1;
}
/* Compact helper */
.form-compact .custom-text-field .v-input__control .v-input__slot,
.form-compact .custom-select-field .v-input__slot {
  padding-block: 12px; border-radius: 14px !important;
}
/* Small screens: full width & extra tap target */
@media (max-width: 600px) {
  .custom-text-field .v-input__control .v-input__slot,
  .custom-select-field .v-input__slot { padding-block: 18px; border-radius: 18px !important; }
  .custom-text-field input, .custom-select-field input { font-size: 18px; }
}

/* ---------- Buttons ---------- */
.buttongenerate {
  background-color: rgba(255,255,255,0.10);
  border: 1px solid rgba(255,255,255,0.26);
  color: #fff;
  border-radius: 14px;
  height: 50px;
  min-width: 240px;
  padding: 0 16px;
  margin: 20px;
  transition: transform .15s ease, box-shadow .2s ease, background-color .2s ease, border-color .2s ease;
}
.buttongenerate:hover {
  background-color: rgba(255,255,255,0.18);
  border-color: rgba(66,218,145,0.45);
  box-shadow: 0 6px 18px rgba(0,0,0,0.35);
  transform: translateY(-1px);
}
.buttongenerate2:disabled {
  background-color: rgba(255,255,255,0.06);
  border-color: rgba(255,255,255,0.12);
  color: rgba(233,245,255,0.55);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}
/* ---------- Microphone icon ---------- */
@keyframes pulse { 0%{transform:scale(1)} 50%{transform:scale(1.2)} 100%{transform:scale(1)} }
.mdi-microphone { top: -6px; animation: pulse 1.1s infinite; color: var(--accent) }

/* ---------- Overlay / loading ---------- */
.overlay {
  position: fixed; inset: 0;
  display: grid; place-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
.animated-image { transform: scale(0); animation: scaleIn .5s forwards, fadeOut .5s 5s forwards; }
@keyframes scaleIn { to { transform: scale(1) } }
@keyframes fadeOut { to { opacity: 0 } }
.loading-container {
  background: rgba(12, 22, 27, 0.5);
  border: 1px solid rgba(120,204,226,0.22);
  color: var(--ink);
  padding: 12px 14px;
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(0,0,0,0.35);
  text-align: center;
  font-size: 1.05rem;
}

/* ---------- Generated image full-view ---------- */
.bookimage-container {
  position: fixed; inset: 0;
  background: linear-gradient(180deg, rgba(12,22,27,0.96), rgba(12,22,27,0.92));
  z-index: 10000;
  display: grid; place-items: center;
  padding: 60px 14px 20px;
}
.bookimage-container img {
  max-width: min(1200px, 92vw);
  max-height: 78vh;
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.12);
  box-shadow: 0 18px 25px rgba(0,0,0,0.55);
}

/* ---------- Saved images & lightbox ---------- */
.saved-images-container {
  padding: 16px;
  border: 1px solid rgba(29,50,59,0.9);
  border-radius: 10px;
  margin-top: -8px;
  background: rgba(29,50,59,0.78);
  box-shadow: inset 0 20px 40px rgba(0,0,0,0.15), inset 0 -10px 18px rgba(255,255,255,0.05);
}

/* Thumbnails */
.image-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 14px;
  list-style: none;
  padding: 0;
  margin: 0;
}
.image-thumb {
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,0.10);
  background: rgba(255,255,255,0.06);
  transition: transform .18s ease, box-shadow .2s ease, border-color .2s ease;
}
.image-thumb:hover {
  transform: translateY(-2px);
  border-color: rgba(66,218,145,0.45);
  box-shadow: 0 10px 24px rgba(0,0,0,0.35), 0 0 0 1px rgba(66,218,145,0.18) inset;
}
.image-thumb img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  display: block;
}

/* Overlay */
.lightbox-overlay {
  position: fixed;
  inset: 0;
  background: rgba(6, 12, 15, 0.72);
  backdrop-filter: blur(6px);
  display: grid;
  place-items: center;
  z-index: 11000;
  outline: none;
}

/* Dialog card */
.lightbox-card {
  position: relative;
  width: min(1000px, 92vw);
  max-height: 84vh;
  background: linear-gradient(180deg, rgba(12,22,27,0.96), rgba(12,22,27,0.90));
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 16px;
  padding: 18px 18px 14px;
  box-shadow: 0 24px 60px rgba(0,0,0,0.55);
  display: grid;
  grid-template-rows: 1fr auto auto;
  gap: 12px;
}

/* Big animated close button (top-right) */
.lightbox-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 56px;
  height: 56px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.22);
  background: radial-gradient(120% 120% at 50% 50%, rgba(255,255,255,0.14), rgba(255,255,255,0.06));
  color: var(--ink, #fff);
  font-size: 28px;
  line-height: 1;
  display: grid;
  place-items: center;
  cursor: pointer;
  animation: panelPulse 1.6s ease-in-out infinite;
  transition: transform .18s ease, box-shadow .2s ease, border-color .2s ease, opacity .2s ease;
}
.lightbox-close:hover {
  transform: translateY(-1px) rotate(90deg) scale(1.06);
  border-color: rgba(66,218,145,0.55);
  box-shadow: 0 16px 28px rgba(0,0,0,0.45), 0 0 0 1px rgba(66,218,145,0.25) inset;
}
@keyframes panelPulse {
  0%,100% { box-shadow: 0 12px 24px rgba(0,0,0,0.35), inset 0 0 0 1px rgba(255,255,255,0.05); }
  50%     { box-shadow: 0 14px 26px rgba(0,0,0,0.42), 0 0 18px rgba(66,218,145,0.25), inset 0 0 0 1px rgba(255,255,255,0.07); }
}

/* Media area */
.lightbox-media {
  width: 100%;
  max-height: 64vh;
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.10);
  overflow: hidden;
  background: rgba(0,0,0,0.25);
}
.lightbox-media img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Prompt/meta + actions */
.lightbox-meta {
  color: var(--ink, #e9f5ff);
  font-size: 14px;
  opacity: .9;
}
.lightbox-meta .prompt {
  white-space: pre-wrap;
  word-break: break-word;
}

.lightbox-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

/* Transition */
.fade-zoom-enter-active, .fade-zoom-leave-active {
  transition: opacity .18s ease, transform .18s ease;
}
.fade-zoom-enter, .fade-zoom-leave-to {
  opacity: 0;
  transform: scale(.98);
}
.image-gallery > li { break-inside: avoid; margin-bottom: 10px; cursor: pointer; list-style: none; }

.lightbox {
  position: fixed; width: 60%; height: 60%;
  top: 44%; left: 50%; color: #fff; transform: translate(-50%, -50%);
  background: linear-gradient(90deg, #0c161bd5, #0c161b8b);
  z-index: 1000; border-radius: 10px; text-align: center;
}

.image-gallery li img { object-fit: cover; width: 100%; height: 100%; vertical-align: middle; border-radius: 5px; }
.image-gallery li .v-btn {
  opacity: 0.8; outline: 1px solid #fff; margin: 10px;
  background-color: rgba(0, 0, 139, 0.6); color: white; border: none; border-radius: 4px;
}
.image-gallery li .v-btn:hover { opacity: 1; }
/* ---------- Prompt row under each page ---------- */
.d-flex.mt-2 .v-text-field .v-input__slot {
  background: var(--glass) !important;
  border: 1px solid rgba(255,255,255,0.09);
  border-radius: 12px;
}
.d-flex.mt-2 .v-btn { border-radius: 12px; }

/* ---------- Form prompt ---------- */
.inputarea {
  width: 100%; min-height: 56px;
  padding: 12px 16px;
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 14px;
  background: rgba(255,255,255,0.06);
  color: var(--ink);
}

/* ---------- Responsive tweaks ---------- */
@media (max-width: 1264px) { .page-image img { height: 240px } }
@media (max-width: 600px)  { .page-image img { height: 200px } .buttongenerate { min-width: 100% } }

/* ---------- Chapters basic ---------- */
.chapters { margin-top: 20px; font-size: 16px; color: #fff }

/* ---------- Utility focus ring ---------- */
:focus-visible {
  outline: 2px solid var(--accent-2);
  outline-offset: 2px;
  border-radius: 8px;
}

/* ---------- Small shimmer for captions/status ---------- */
.caption, .status { position: relative; }
.caption::after, .status::after {
  content:"";
  position:absolute; left:0; right:0; bottom:-1px; height:1px;
  background: linear-gradient(90deg, transparent, rgba(120,204,226,0.6), transparent);
  opacity:.35;
  animation: shimmer 2.2s linear infinite;
}
@keyframes shimmer { 0%{ transform: translateX(-40%) } 100%{ transform: translateX(40%) } }

/* ======= Book Viewer styles ======= */
.book-viewer {
  background: rgba(15, 26, 32, 0.92);
  border: 1px solid rgba(255,255,255,0.08);
  backdrop-filter: blur(8px);
}
.flipbook-wrap {
  display: grid;
  place-items: center;
  perspective: 1200px;
  margin-top: 8px;
}
.spread {
  width: min(1040px, 94vw);
  height: min(640px, 70vh);
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  background:
    linear-gradient(90deg, rgba(0,0,0,0.12), rgba(0,0,0,0) 20%, rgba(0,0,0,0) 80%, rgba(0,0,0,0.12)),
    radial-gradient(800px 200px at 50% -40%, rgba(120,204,226,0.12), transparent);
  border-radius: 12px;
  box-shadow: 0 30px 70px rgba(0,0,0,0.5);
  position: relative;
}
.spread::before {
  content: "";
  position: absolute; left: 50%; top: 0; bottom: 0; width: 2px;
  background: linear-gradient(180deg, rgba(0,0,0,0.45), rgba(255,255,255,0.08), rgba(0,0,0,0.45));
  transform: translateX(-50%);
  opacity: 0.6;
}
.book-page {
  background: linear-gradient(180deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02));
  border-right: 1px solid rgba(255,255,255,0.06);
  position: relative;
  overflow: hidden;
}
.book-page:last-child { border-right: none; }
.page-inner {
  padding: 18px 18px 18px 22px;
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 12px;
}
.page-title {
  margin: 4px 0 6px;
  font-weight: 700;
  letter-spacing: .02em;
}
.page-pre {
  white-space: pre-wrap;
  font-family: ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  color: #e6f3ff;
  font-size: 14.5px;
  line-height: 1.55;
  padding-right: 6px;
}
.thumbs {
  display: flex; flex-wrap: wrap; gap: 10px; margin-top: 14px;
}
.thumb {
  width: 92px; height: 72px; border-radius: 8px;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.08);
  overflow: hidden; position: relative; cursor: pointer;
  transition: transform .15s ease, border-color .15s ease;
}
.thumb:hover { transform: translateY(-2px); border-color: rgba(66,218,145,0.4); }
.thumb.active { box-shadow: 0 0 0 2px rgba(66,218,145,0.6) inset; }
.thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
.thumb-text {
  width: 100%; height: 100%;
  display: grid; place-items: center;
  font-size: 11px; color: #a9c1cc; text-align: center; padding: 6px;
}
.thumb-label {
  position: absolute; right: 6px; bottom: 2px; font-size: 11px; color: #a9c1cc;
}
.images-panel {
  position: relative;
}

/* Animated Close Button (top-right) */
.panel-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 56px;
  height: 56px;
  border-radius: 999px !important;
  background: radial-gradient(120% 120% at 50% 50%, rgba(255,255,255,0.14), rgba(255,255,255,0.06)) !important;
  border: 1px solid rgba(255,255,255,0.22) !important;
  color: #fff !important;
  box-shadow: 0 12px 24px rgba(0,0,0,0.35), inset 0 0 0 1px rgba(255,255,255,0.05) !important;
  animation: panelPulse 1.6s ease-in-out infinite;
  transition: transform .18s ease, box-shadow .2s ease, border-color .2s ease;
  z-index: 5;
}
.panel-close:hover {
  transform: translateY(-1px) rotate(90deg) scale(1.06);
  border-color: rgba(66,218,145,0.55) !important;
  box-shadow: 0 16px 28px rgba(0,0,0,0.45), 0 0 0 1px rgba(66,218,145,0.25) inset !important;
}
.panel-close:focus-visible {
  outline: 2px solid var(--accent-2);
  outline-offset: 2px;
}
@keyframes panelPulse {
  0%,100% { box-shadow: 0 12px 24px rgba(0,0,0,0.35), inset 0 0 0 1px rgba(255,255,255,0.05); }
  50%     { box-shadow: 0 14px 26px rgba(0,0,0,0.42), 0 0 18px rgba(66,218,145,0.25), inset 0 0 0 1px rgba(255,255,255,0.07); }
}
/* >>> ADD: viewer typography variations */
.story-typography { font-size: 15.5px; line-height: 1.65; }
.kids-typography  { font-size: 14px; line-height: 1.1; letter-spacing: .1px; }
.comic-typography { font-size: 14.5px; line-height: 1.55; text-transform: none; }

/* Comic panel grid */
.comic-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: minmax(140px, auto);
  gap: 10px;
}
.comic-grid .panel {
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 8px;
  background: rgba(255,255,255,0.04);
  overflow: hidden;
  display: grid;
  grid-template-rows: auto 1fr;
}
.comic-grid .panel img { width: 100%; height: 180px; object-fit: cover; }
.comic-grid .panel-text { padding: 8px 10px; color: #e6f3ff; }

</style>
